/* eslint-disable */

export var Ble = {
  /**
   * スキャンで見つかったデバイス郡です。
   * nameプロパティで名前、addressプロパティでアドレスを参照します。
   *
   * @type {Array}
   */
  foundDevices: [],
  /**
   * BLEから取得したデータのキャッシュです。
   * BLEデバイスのタイプによってプロパティが異なります。
   *
   * [共通プロパティ]
   * deviceType: BLEデバイスのタイプ(今回サポートするNo.1-10の番号が入ります), Number型
   * bytes: BLEデバイスから取得されたバイト列(ArrayBuffer型)
   * datetime: データを取得したタイムスタンプ(readValueメソッドでコマンドを実行して初めてデータが取得されるタイプは空文字), Date型
   * invalid: 取得した値が不正かどうか(Boolean型)
   *
   * [BLEデバイス固有のプロパティ]
   * - deviceTypeが1
   * systolicPressure(血圧上[mmHg], Number型), diastolicPressure(血圧下[mmHg], Number型), pr(脈拍[bpm], Number型)
   * 上記の値が全て2047の場合は不正な値とする
   * - deviceTypeが2
   * systolicPressure(血圧上[mmHg], Number型), diastolicPressure(血圧下[mmHg], Number型), pr(脈拍[bpm], Number型), measurementTime(測定時刻, Date型)
   * 上記の値が全て2047の場合は不正な値とする
   * - deviceTypeが3
   * temperature(体温[℃], Number型)
   * 体温の4バイトが0xFF, 0xFF, 0x7F, 0x00になる場合は不正な値とする
   * - deviceTypeが4
   * glucose(血糖値[mg/dL], Number型)
   * Flagsの2ビット目(Sensor Status Annunciation Present)が1になる場合は不正な値とする
   * - deviceTypeが5
   * spo2(SpO2[%], Number型), pr(脈拍数[bpm], Number型)
   * Measurement StatusのValidated DataとにFully Qualified Dataが1の場合は不正な値とする
   * - deviceTypeが6
   * 心電波形と心拍数の２通りの値を取得
   * 心電波形：ecg(心電波形配列[mV], Number型の配列), trigger1(1つ目のR-TriggerのECGサンプリング番号, Number型), trigger2(2つ目のR-TriggerのECGサンプリング番号, Number型), measurementTime(測定時刻, Date型)
   * 心拍数：pr(心拍数[bpm]), measurementTime(測定時刻)
   * - deviceTypeが7
   * spo2(SpO2[%], Number型), pr(脈拍数[bpm], Number型)
   * Measurement Statusの脈未検出, 指外れ, 外光エラー, コネクタ外れのフラグが立っている場合は不正な値とする
   * また、spo2とprのいずれかが測定値が未確定の場合も不正な値とする(spo2は[0x7F, 0xFF], prは[0xFF, 0xFF])
   * - deviceTypeが9
   * temperature(体温[℃], Number型), measurementTime(測定時刻, Date型)
   * 体温の4バイトが0xFF, 0xFF, 0x7F, 0x00になる場合は不正な値とする
   *
   * @type {Object}
   */
  readVal: {
    deviceType: -1,
    bytes: '',
    datetime: '',
    invalid: false,
    spo2: '',
    pr: '',
    systolicPressure: '',
    diastolicPressure: '',
    temperature: '',
    measurementTime: '',
    ecg: '',
    trigger1: '',
    trigger2: '',
    heartRate: '',
    glucose: ''
  },
  _foundAllDevices: [],
  _notifiedDisconnected: {},
  _addDevice: '',
  _connectSuccess: '',
  _connectError: '',
  _connecting: false,
  _disconnecting: false,
  _receivedValueListener: {},
  _uuid: '',
  _constantECG: true,
  _termHR: 5,
  _ecgConfigCharacteristicUuid: '',
  _noiseFilter: null,
  _userControl: '',

  /*
   * @type { function }
   */
  onChangeFoundDevices: function() {},
  onChangeReadVal: function() {},

  /**
   * Bluetooth機能を利用するための初期化します。
   * 本ライブラリを使う前に実行してください。端末のBluetoothがオフの場合は、変更ダイアログが表示されます。
   * 現状はライブラリの影響でコールバックは実行されません。
   * @param  {function} handleSuccess 成功した場合に実行されるコールバック
   * @param  {function} handleError 失敗した場合に実行されるコールバック
   * @return {Promise} 機能実行後に各種コールバックを実行するPromise
   */
  init: function(handleSuccess, handleError) {
    _uuid = device.uuid.split('')

    //ライブラリの不備でcallbackが呼ばれない(機能はする)
    //https://github.com/randdusing/cordova-plugin-bluetoothle/issues/477
    return new Promise(function(resolve) {
      bluetoothle.initialize(resolve, { request: true, statusReceiver: false })
    }).then(handleSuccess, handleError)
  },

  /**
   * スキャンを開始します。
   * 検出されたデバイスはfoundDevicesで確認できます。foundDevicesは本メソッドが呼ばれる際にクリアされます。
   * paramsはサポートするデバイスは下記の通りです。
   * No.10デバイスの場合:
   * - {"setupNo10": true}で初期設定(Noの登録)が可能な状態になっているデバイスを検出します。
   * - それ以外の場合はアプリ無し測定モード(接続すると値が取得できる状態)のデバイスを検出します。
   * @param  {function} addDevice デバイスが見つかった際に実行されるコールバック
   * @param  {function} handleError 失敗した場合に実行されるコールバック
   * @param  {object} params 設定可能なパラメータ
   */
  startScan: function(addDevice, handleError, params) {
    console.log('Starting scan for devices...', 'status')

    this.foundDevices = []
    this._addDevice = addDevice

    var services = [
      '1810',
      '1809',
      '5D87A4A0-E42D-11E5-BEEF-0002A5D5C51B',
      '1822',
      'C74D1000-457D-4194-8B37-E7188723AEA9',
      '23444100-9C95-1740-A38A-000BDB712C7C'
    ]

    if (
      typeof params !== 'undefined' &&
      params != null &&
      params.setupNo10 == true
    ) {
      services.push('11127001-B364-11E4-AB27-0800200C9A66')
    } else {
      services.push('181D')
    }

    bluetoothle.startScan(this._startScanSuccess.bind(this), handleError, {
      services: services,
      isConnectable: true
    })
  },

  /**
   * スキャンを停止します。
   * 検出されたデバイスはfoundDevicesで確認できます。foundDevicesは本メソッドが呼ばれる際にクリアされます。
   * @param  {function} handleSuccess 成功した場合に実行されるコールバック
   * @param  {function} handleError 失敗した場合に実行されるコールバック
   * @return {Promise} 機能実行後に各種コールバックを実行するPromise
   */
  stopScan: function(handleSuccess, handleError) {
    return new Promise(function(resolve, reject) {
      bluetoothle.stopScan(resolve, reject)
    }).then(handleSuccess, handleError)
  },

  /**
   * BLEデバイスと接続します。値の取得に必要な設定も行います。
   * paramsはサポートするデバイスは下記の通りです。
   * No.6デバイスの場合: changeEcgConfigCharacteristicメソッドを参照
   * No.10デバイスの場合: {"userControl": "add"}でID=1を削除し登録, {"userControl": "remove"}でID=1を削除
   * @param  {string} address 接続対象のアドレス
   * @param  {function} handleSuccess 成功した場合に実行されるコールバック
   * @param  {function} handleError 失敗した場合に実行されるコールバック
   * @param  {function} disconnectCallback 切断された場合に実行されるコールバック
   * @param  {object} params デバイス毎に設定可能なパラメータ
   * @return {Promise} 機能実行後に各種コールバックを実行するPromise
   */
  connect: function(
    address,
    handleSuccess,
    handleError,
    disconnectCallback,
    params
  ) {
    console.log('connect: ' + address + '...')

    this._setupParams(address, params)

    this._notifiedDisconnected[address] = false

    this._connecting = true

    this._connectSuccess = handleSuccess
    this._connectError = () => {
      this._close(address).finally(() => {
        if (this._connecting) {
          handleError('Failed to connect')
        } else {
          if (this._notifiedDisconnected[address] == false) {
            this._notifiedDisconnected[address] = true
            disconnectCallback()
          }
        }
      })
    }

    this._connect(address)
      .then(result => {
        return this._conSuccess(result)
      })
      .catch(error => {
        handleError(error)
      })
      .finally(() => {
        this._connecting = false
      })
  },

  /**
   * BLEデバイスと切断します。
   * @param  {string} address 接続対象のアドレス
   * @param  {function} handleSuccess 成功した場合に実行されるコールバック
   * @param  {function} handleError 失敗した場合に実行されるコールバック
   * @return {Promise} 機能実行後に各種コールバックを実行するPromise
   */
  disconnect: function(address, handleSuccess, handleError) {
    this._disconnecting = true

    var platform = window.cordova.platformId
    if (platform !== 'windows') {
      this._disconnect(address)
        .then(() => {
          return this._close(address)
        })
        .then(() => {
          handleSuccess()
        })
        .catch(error => {
          handleError(error)
        })
        .finally(() => {
          this._disconnecting = false
        })
    } else {
      this._close(address)
        .then(() => {
          handleSuccess()
        })
        .catch(error => {
          handleError(error)
        })
        .finally(() => {
          this._disconnecting = false
        })
    }
  },

  /**
   * BLEデバイスから値を取得した場合に実行するイベントハンドラを登録します。
   * @param {string} address 接続対象のアドレス
   * @param {function} listener BLEデバイスから値を取得した場合に実行されるメソッド(引数にreadValプロパティを渡します)
   */
  addReceivedValueListener: function(address, listener) {
    this._receivedValueListener[address] = listener
  },

  /**
   * 注意) 現状は使用しません。
   * BLEデバイスに対して値を要求します。
   * 送付された値はaddReceivedValueListnerで受け取ります。
   * - 取得コマンドを実行してデータを取得するタイプのBLEデバイス: コマンドを実行します
   * - 接続後に定期的/特定のタイミングでデータを送付するBLEデバイス: 何も動作しません
   * @param  {string} address 接続対象のアドレス
   * @param  {function} handleSuccess 成功した場合に実行されるコールバック
   * @param  {function} handleError 失敗した場合に実行されるコールバック
   * @return {Promise} 機能実行後に各種コールバックを実行するPromise
   */
  requestValue: function(address, handleSuccess, handleError) {
    new Promise(
      function(resolve, reject) {
        resolve()
      }.bind(this)
    ).then(handleSuccess, handleError)
  },

  /**
   * 動作モードを設定します(No.6デバイス専用のメソッドです)。
   * paramsはconstantECG(*true,false), termHR(*5,10,30,60)です(*はデフォルト値)。
   * 例) ECG常時接続、心拍数の送信間隔 10秒の場合、params={constantECG: true, termHR: 10}
   * @param  {string} address 接続対象のアドレス
   * @param  {function} handleSuccess 成功した場合に実行されるコールバック
   * @param  {function} handleError 失敗した場合に実行されるコールバック
   * @param  {object} params デバイス毎に設定可能なパラメータ
   * @return {Promise} 機能実行後に各種コールバックを実行するPromise
   */
  changeNC1BLEConfig: function(address, handleSuccess, handleError, params) {
    this._setupParams(address, params)

    return new Promise(
      function(resolve, reject) {
        if (!this._isNumber6Device(address)) {
          reject('This device is not No.6 device')
        }
        if (this._ecgConfigCharacteristicUuid == '') {
          reject('This device is not connected')
        }

        console.log(
          '[ecgConfigCharacteristic] ecg:' +
            this._constantECG +
            ', HR:' +
            this._termHR
        )

        let buffer = new Uint8Array([
          2,
          0,
          0x00,
          0x00,
          0x00,
          0x00,
          0x00,
          0x00,
          0x00,
          0x00
        ]).buffer
        let dataView = new DataView(buffer)

        if (this._constantECG == true) {
          dataView.setUint8(0, 2) //ECG常時計測 2
        } else if (this._constantECG == false) {
          dataView.setUint8(0, 0) //ECG通常計測 0
        }

        if (this._termHR == 0) {
          dataView.setUint8(1, 0) //心拍数の送信間隔 5秒 0
        } else if (this._termHR == 10) {
          dataView.setUint8(1, 1) //心拍数の送信間隔 10秒 1
        } else if (this._termHR == 30) {
          dataView.setUint8(1, 2) //心拍数の送信間隔 30秒 2
        } else if (this._termHR == 60) {
          dataView.setUint8(1, 3) //心拍数の送信間隔 60秒 3
        }

        //iPhone識別用UUIDの先頭8文字を格納する
        //...と仕様では記載があるが、設定するとすECG常時計測でもすぐに切断される模様
        //公開されているアプリに合わせて全て0x00とする
        // dataView.setUint8(_uuid[0])
        // dataView.setUint8(_uuid[1])
        // dataView.setUint8(_uuid[2])
        // dataView.setUint8(_uuid[3])
        // dataView.setUint8(_uuid[4])
        // dataView.setUint8(_uuid[5])
        // dataView.setUint8(_uuid[6])
        // dataView.setUint8(_uuid[7])

        console.log(buf2hex(dataView.buffer))

        var value = bluetoothle.bytesToEncodedString(
          new Uint8Array(dataView.buffer)
        )

        bluetoothle.write(resolve, reject, {
          address: address,
          service: 'C74D1000-457D-4194-8B37-E7188723AEA9',
          characteristic: this._ecgConfigCharacteristicUuid,
          value: value,
          type: 'Response'
        })
      }.bind(this)
    ).then(handleSuccess, handleError)
  },

  /**
   * デバイス名が"ニプロ電子血圧計 ニプロ（A＆D）NBP-1BLE"かどうか判定します。
   * デバイス名のプレフィックスが"A&D_UA-651BLE"または"NBP-1BLE"かどうかで判断します。
   * @param  {string} name デバイス名
   * @return {boolean} 該当するかどうか
   */
  isNumber1Device: function(name) {
    return name.indexOf('A&D_UA-651BLE') === 0 || name.indexOf('NBP-1BLE') === 0
  },

  /**
   * デバイス名が"ニプロ医科向け血圧計 ニプロ UM-212"かどうか判定します。
   * デバイス名のプレフィックスが"NMBP"かどうかで判断します。
   * @param  {string} name デバイス名
   * @return {boolean} 該当するかどうか
   */
  isNumber2Device: function(name) {
    return name.indexOf('NMBP') === 0
  },

  /**
   * デバイス名が"ニプロ電子体温計 ニプロ NSM-1BLE"かどうか判定します。
   * デバイス名のプレフィックスが"NSM-1BLE"かどうかで判断します。
   * @param  {string} name デバイス名
   * @return {boolean} 該当するかどうか
   */
  isNumber3Device: function(name) {
    return name.indexOf('NSM-1BLE') === 0
  },

  /**
   * デバイス名が"血糖測定器 ニプロ ケアファストLink"かどうか判定します。
   * デバイス名のプレフィックスが"NIPRO CF"かどうかで判断します。
   * @param  {string} name デバイス名
   * @return {boolean} 該当するかどうか
   */
  isNumber4Device: function(name) {
    return name.indexOf('NIPRO CF') === 0
  },

  /**
   * デバイス名が"SPO2モニター（スポット） MASIMO マイティサット"かどうか判定します。
   * デバイス名のプレフィックスが"MightySat"かどうかで判断します。
   * @param  {string} name デバイス名
   * @return {boolean} 該当するかどうか
   */
  isNumber5Device: function(name) {
    return name.indexOf('MightySat') === 0
  },

  /**
   * デバイス名が"心電送信機: ECG Service (独自) 心電波形、心拍数"かどうか判定します。
   * デバイス名のプレフィックスが"NC"かどうかで判断します。
   * @param  {string} name デバイス名
   * @return {boolean} 該当するかどうか
   */
  isNumber6Device: function(name) {
    return name.indexOf('NC') === 0
  },

  /**
   * デバイス名が"SPO2モニター（24ｈ式）"かどうか判定します。
   * デバイス名のプレフィックスが"TM1121"かどうかで判断します。
   * @param  {string} name デバイス名
   * @return {boolean} 該当するかどうか
   */
  isNumber7Device: function(name) {
    return name.indexOf('TM1121') === 0
  },

  /**
   * デバイス名が"非接触体温計"かどうか判定します。
   * デバイス名のプレフィックスが"NT-100B"かどうかで判断します。
   * @param  {string} name デバイス名
   * @return {boolean} 該当するかどうか
   */
  isNumber9Device: function(name) {
    return name.indexOf('NT-100B') === 0
  },

  /**
   * デバイス名が"体組成計"かどうか判定します。
   * デバイス名のプレフィックスが"NBCM"または"UC-421BLE"かどうかで判断します。
   * @param  {string} name デバイス名
   * @return {boolean} 該当するかどうか
   */
  isNumber10Device: function(name) {
    return name.indexOf('NBCM') === 0 || name.indexOf('UC-421BLE') === 0
  },

  _setupParams: function(address, params) {
    if (this._isNumber6Device(address)) {
      if (typeof params !== 'undefined' && params != null) {
        if (params.constantECG == null) {
          this._constantECG = true
        } else {
          this._constantECG = params.constantECG
        }
        if (params.termHR == null) {
          this._termHR = 0
        } else {
          this._termHR = params.termHR
        }
      }
    } else if (this._isNumber10Device(address)) {
      this._userControl = ''
      if (typeof params !== 'undefined' && params != null) {
        this._userControl = params.userControl
      }
    }
  },

  _retrieveConnectedSuccess: function(result) {
    console.log('_retrieveConnectedSuccess()')
    console.log(result)

    result.forEach(function(device) {
      this._addDevice(device.name, device.address)
    })
  },

  _startScanSuccess: function(result) {
    if (result.status === 'scanStarted') {
      console.log(
        'Scanning for devices (will continue to scan until you select a device)...',
        'status'
      )
    } else if (result.status === 'scanResult') {
      if (
        !this._foundAllDevices.some(function(device) {
          return device.address === result.address
        })
      ) {
        this._foundAllDevices.push(result)
      }

      if (
        !this.foundDevices.some(function(device) {
          return device.address === result.address
        })
      ) {
        console.log('FOUND DEVICE:')
        this.foundDevices.push(result)
        this.onChangeFoundDevices()
        this._addDevice(result.name, result.address)
      }
    }
  },

  _conSuccess: function(result) {
    if (result.status === 'connected') {
      // bluetoothle.mtu(()=>{
      //     this._getDeviceServices(result.address)
      // }, this._connectError, {"address": result.address, "mtu":256});
      return this._getDeviceServices(result.address)
    } else if (result.status === 'disconnected') {
      console.log('Disconnected from device: ' + result.address, 'status')
      return this._close(result.address).then(() => {
        throw new Error('disconnected')
      })
    }
  },

  _getDeviceServices: function(address) {
    console.log('Getting device services...', 'status')
    var platform = window.cordova.platformId
    if (platform !== 'ios') {
      return new Promise(function(resolve, reject) {
        bluetoothle.discover(resolve, reject, { address: address })
      }).then(this._discoverSuccess.bind(this), this._connectError)
    } else {
      return new Promise(function(resolve, reject) {
        bluetoothle.services(resolve, reject, { address: address })
      }).then(this._servicesSuccess.bind(this), this._connectError)
    }
  },

  _discoverSuccess: function(result) {
    console.log('Discover returned with status: ' + result.status)

    if (result.status === 'discovered') {
      // Create a chain of read promises so we don't try to read a property until we've finished
      // reading the previous property.
      var readSequence = result.services.reduce(
        function(sequence, service) {
          return sequence.then(
            function() {
              return this._addService(
                result.address,
                service.uuid,
                service.characteristics
              )
            }.bind(this)
          )
        }.bind(this),
        Promise.resolve()
      )

      readSequence.then(this._connectSuccess)
    }
  },

  _servicesSuccess: function(result) {
    console.log('_servicesSuccess()')

    if (result.status === 'services') {
      var readSequence = result.services.reduce(
        function(sequence, service) {
          return sequence.then(
            function() {
              console.log('Executing promise for service: ' + service)
              return new Promise(function(resolve, reject) {
                bluetoothle.characteristics(resolve, reject, {
                  address: result.address,
                  service: service
                })
              }).then(this._characteristicsSuccess.bind(this), function(e) {
                console.log(JSON.stringify(e))
              })
            }.bind(this),
            this._connectError
          )
        }.bind(this),
        Promise.resolve()
      )

      readSequence.then(this._connectSuccess)
    }
  },

  _characteristicsSuccess: function(result) {
    console.log('_characteristicsSuccess()')
    console.log(result)
    if (result.status === 'characteristics') {
      return this._addService(
        result.address,
        result.service,
        result.characteristics
      )
    }
  },

  _addService: function(address, serviceUuid, characteristics) {
    console.log('Adding service ' + serviceUuid)

    var readSequence = Promise.resolve()

    if (this._isNumber5Device(address)) {
      const characteristic = characteristics.find(
        characteristic => characteristic.uuid == '2A5E'
      )
      if (serviceUuid == '1822' && characteristic) {
        bluetoothle.subscribe(
          this._subscribeSuccess.bind(this),
          function(e) {
            if (this._disconnecting) {
              return
            }
            this._connectError(e)
          }.bind(this),
          {
            address: address,
            service: serviceUuid,
            characteristic: characteristic.uuid
          }
        )
      }
    } else if (
      this._isNumber1Device(address) ||
      this._isNumber2Device(address)
    ) {
      const characteristic = characteristics.find(
        characteristic => characteristic.uuid == '2A35'
      )
      if (serviceUuid == '1810' && characteristic) {
        if (characteristic.properties.indicate) {
          bluetoothle.subscribe(
            this._subscribeSuccess.bind(this),
            function(e) {
              if (this._disconnecting) {
                return
              }
              this._connectError(e)
            }.bind(this),
            {
              address: address,
              service: serviceUuid,
              characteristic: characteristic.uuid
            }
          )
        }
      }
    } else if (
      this._isNumber3Device(address) ||
      this._isNumber9Device(address)
    ) {
      const characteristic = characteristics.find(
        characteristic => characteristic.uuid == '2A1C'
      )
      if (serviceUuid == '1809' && characteristic) {
        if (
          characteristic.properties.indicate ||
          characteristic.properties.notify
        ) {
          bluetoothle.subscribe(
            this._subscribeSuccess.bind(this),
            function(e) {
              if (this._disconnecting) {
                return
              }
              this._connectError(e)
            }.bind(this),
            {
              address: address,
              service: serviceUuid,
              characteristic: characteristic.uuid
            }
          )
        }
      }
    } else if (this._isNumber6Device(address)) {
      console.log(serviceUuid)

      if (serviceUuid == 'C74D1000-457D-4194-8B37-E7188723AEA9') {
        //全てのcharacteristicにnotifyしないと動作しない
        characteristics.forEach((characteristic, index) => {
          if (
            characteristic.properties.notify ||
            characteristic.properties.indicate
          ) {
            bluetoothle.subscribe(
              this._subscribeSuccess.bind(this),
              function(e) {
                if (this._disconnecting) {
                  return
                }
                this._connectError(e)
              }.bind(this),
              {
                address: address,
                service: serviceUuid,
                characteristic: characteristic.uuid
              }
            )
          }
        })

        const ecgConfigCharacteristic = characteristics.find(
          characteristic =>
            characteristic.uuid == 'C74D2001-457D-4194-8B37-E7188723AEA9'
        )
        const datetimeCharacteristic = characteristics.find(
          characteristic => characteristic.uuid == '2A08'
        )

        this._ecgConfigCharacteristicUuid = ecgConfigCharacteristic.uuid

        console.log('ecgConfigCharacteristic')

        let buffer = new Uint8Array([
          2,
          0,
          0x00,
          0x00,
          0x00,
          0x00,
          0x00,
          0x00,
          0x00,
          0x00
        ]).buffer
        let dataView = new DataView(buffer)

        if (this._constantECG == true) {
          dataView.setUint8(0, 2) //ECG常時計測 2
        } else if (this._constantECG == false) {
          dataView.setUint8(0, 0) //ECG通常計測 0
        }

        if (this._termHR == 0) {
          dataView.setUint8(1, 0) //心拍数の送信間隔 5秒 0
        } else if (this._termHR == 10) {
          dataView.setUint8(1, 1) //心拍数の送信間隔 10秒 1
        } else if (this._termHR == 30) {
          dataView.setUint8(1, 2) //心拍数の送信間隔 30秒 2
        } else if (this._termHR == 60) {
          dataView.setUint8(1, 3) //心拍数の送信間隔 60秒 3
        }

        //iPhone識別用UUIDの先頭8文字を格納する
        //...と仕様では記載があるが、設定するとすECG常時計測でもすぐに切断される模様
        //公開されているアプリに合わせて全て0x00とする
        // dataView.setUint8(_uuid[0])
        // dataView.setUint8(_uuid[1])
        // dataView.setUint8(_uuid[2])
        // dataView.setUint8(_uuid[3])
        // dataView.setUint8(_uuid[4])
        // dataView.setUint8(_uuid[5])
        // dataView.setUint8(_uuid[6])
        // dataView.setUint8(_uuid[7])

        console.log(buf2hex(dataView.buffer))

        var value = bluetoothle.bytesToEncodedString(
          new Uint8Array(dataView.buffer)
        )

        this._write(address, serviceUuid, ecgConfigCharacteristic, value)
          .then(() => {
            console.log('datetimeCharacteristic')

            let buffer = new Uint8Array([255, 255, 255, 255, 255, 255, 255])
              .buffer
            let dataView = new DataView(buffer)

            const date = new Date()
            dataView.setUint16(0, date.getFullYear(), true)
            dataView.setUint8(2, date.getMonth() + 1)
            dataView.setUint8(3, date.getDate())
            dataView.setUint8(4, date.getHours())
            dataView.setUint8(5, date.getMinutes())
            dataView.setUint8(6, date.getSeconds())

            console.log(buf2hex(dataView.buffer))

            var value = bluetoothle.bytesToEncodedString(
              new Uint8Array(dataView.buffer)
            )
            return this._write(
              address,
              serviceUuid,
              datetimeCharacteristic,
              value
            )
          })
          .catch(error => {
            console.log('catch ' + JSON.stringify(error))
            if (this._disconnecting) {
              return
            }
            this._connectError(error)
          })
      }
    } else if (this._isNumber7Device(address)) {
      const characteristic = characteristics.find(
        characteristic =>
          characteristic.uuid == '23444102-9C95-1740-A38A-000BDB712C7C'
      )
      if (
        serviceUuid == '23444100-9C95-1740-A38A-000BDB712C7C' &&
        characteristic
      ) {
        if (characteristic.properties.notify) {
          bluetoothle.subscribe(
            this._subscribeSuccess.bind(this),
            function(e) {
              if (this._disconnecting) {
                return
              }
              this._connectError(e)
            }.bind(this),
            {
              address: address,
              service: serviceUuid,
              characteristic: characteristic.uuid
            }
          )
        }
      }
    } else if (this._isNumber4Device(address)) {
      const glucoseMeasurementCharacteristic = characteristics.find(
        characteristic =>
          characteristic.uuid == '5D87A4A1-E42D-11E5-BEEF-0002A5D5C51B'
      )
      if (
        serviceUuid == '5D87A4A0-E42D-11E5-BEEF-0002A5D5C51B' &&
        glucoseMeasurementCharacteristic
      ) {
        if (glucoseMeasurementCharacteristic.properties.notify) {
          bluetoothle.subscribe(
            this._subscribeSuccess.bind(this),
            function(e) {
              if (this._disconnecting) {
                return
              }
              this._connectError(e)
            }.bind(this),
            {
              address: address,
              service: serviceUuid,
              characteristic: glucoseMeasurementCharacteristic.uuid
            }
          )
        }
      }

      const glucoseMeasurementContextCharacteristic = characteristics.find(
        characteristic =>
          characteristic.uuid == '5D87A4A2-E42D-11E5-BEEF-0002A5D5C51B'
      )
      if (
        serviceUuid == '5D87A4A0-E42D-11E5-BEEF-0002A5D5C51B' &&
        glucoseMeasurementContextCharacteristic
      ) {
        if (glucoseMeasurementContextCharacteristic.properties.notify) {
          bluetoothle.subscribe(
            this._subscribeSuccess.bind(this),
            function(e) {
              if (this._disconnecting) {
                return
              }
              this._connectError(e)
            }.bind(this),
            {
              address: address,
              service: serviceUuid,
              characteristic: glucoseMeasurementContextCharacteristic.uuid
            }
          )
        }
      }

      const recordAccessControlPointCharacteristic = characteristics.find(
        characteristic =>
          characteristic.uuid == '5D87A4A3-E42D-11E5-BEEF-0002A5D5C51B'
      )
      if (
        serviceUuid == '5D87A4A0-E42D-11E5-BEEF-0002A5D5C51B' &&
        recordAccessControlPointCharacteristic
      ) {
        if (recordAccessControlPointCharacteristic.properties.indicate) {
          bluetoothle.subscribe(
            this._subscribeSuccess.bind(this),
            function(e) {
              if (this._disconnecting) {
                return
              }
              this._connectError(e)
            }.bind(this),
            {
              address: address,
              service: serviceUuid,
              characteristic: recordAccessControlPointCharacteristic.uuid
            }
          )
        }
      }
    } else if (this._isNumber10Device(address)) {
      if (this._userControl == 'add' || this._userControl == 'remove') {
        const characteristicUserControlPoint = characteristics.find(
          characteristic => characteristic.uuid == '2A9F'
        )
        if (serviceUuid == '181C' && characteristicUserControlPoint) {
          setTimeout(() => {
            bluetoothle.subscribe(
              this._subscribeSuccess.bind(this),
              function(e) {
                if (this._disconnecting) {
                  return
                }
                this._connectError(e)
              }.bind(this),
              {
                address: address,
                service: serviceUuid,
                characteristic: characteristicUserControlPoint.uuid
              }
            )
          }, 15000)
        }

        const characteristicCustom = characteristics.find(
          characteristic =>
            characteristic.uuid == '11127002-B364-11E4-AB27-0800200C9A66'
        )
        if (
          serviceUuid == '11127000-B364-11E4-AB27-0800200C9A66' &&
          characteristicCustom
        ) {
          setTimeout(() => {
            bluetoothle.subscribe(
              this._subscribeSuccess.bind(this),
              function(e) {
                if (this._disconnecting) {
                  return
                }
                this._connectError(e)
              }.bind(this),
              {
                address: address,
                service: serviceUuid,
                characteristic: characteristicCustom.uuid
              }
            )
          }, 15000)
        }
      } else {
        const characteristicUserControlPoint = characteristics.find(
          characteristic => characteristic.uuid == '2A9F'
        )
        if (serviceUuid == '181C' && characteristicUserControlPoint) {
          bluetoothle.subscribe(
            this._subscribeSuccess.bind(this),
            function(e) {
              if (this._disconnecting) {
                return
              }
              this._connectError(e)
            }.bind(this),
            {
              address: address,
              service: serviceUuid,
              characteristic: characteristicUserControlPoint.uuid
            }
          )

          let buffer = new Uint8Array([0x02, 0x01, 0x00, 0x00]).buffer
          let dataView = new DataView(buffer)

          console.log(buf2hex(dataView.buffer))

          var value = bluetoothle.bytesToEncodedString(
            new Uint8Array(dataView.buffer)
          )
          this._write(
            address,
            serviceUuid,
            characteristicUserControlPoint,
            value
          )
            .then(() => {
              console.log('written')
            })
            .catch(error => {
              console.log('catch ' + JSON.stringify(error))
              if (this._disconnecting) {
                return
              }
              this._connectError(error)
            })
        }

        const characteristicWeightScale = characteristics.find(
          characteristic => characteristic.uuid == '2A9D'
        )
        if (serviceUuid == '181D' && characteristicWeightScale) {
          if (characteristicWeightScale.properties.indicate) {
            bluetoothle.subscribe(
              this._subscribeSuccess.bind(this),
              function(e) {
                if (this._disconnecting) {
                  return
                }
                this._connectError(e)
              }.bind(this),
              {
                address: address,
                service: serviceUuid,
                characteristic: characteristicWeightScale.uuid
              }
            )
          }
        }

        //体重以外を取得するコード(動作は未確認, 機能は不要のためコメントアウト)
        // const characteristicBodyComposition = characteristics.find(characteristic => characteristic.uuid == "2A9C")
        // if (serviceUuid == "181B" && characteristicBodyComposition) {
        //     if (characteristicBodyComposition.properties.indicate) {
        //         bluetoothle.subscribe(this._subscribeSuccess.bind(this), function (e) {
        //             if (this._disconnecting) {
        //                return;
        //             }
        //             this._connectError(e);
        //         }.bind(this),
        //         { address: address, service: serviceUuid, characteristic: characteristicBodyComposition.uuid });
        //     }
        // }
      }
    }

    return readSequence
  },

  _subscribe: function(address, serviceUuid, characteristic) {
    if (characteristic === 'undefined') {
      return Promise.reject('characteristic not found')
    } else if (
      !(characteristic.properties.indicate || characteristic.properties.notify)
    ) {
      return Promise.reject('characteristic is not indicate')
    }

    console.log('subscribe: ' + address)

    return new Promise(function(resolve, reject) {
      bluetoothle.subscribe(resolve, reject, {
        address: address,
        service: serviceUuid,
        characteristic: characteristic.uuid
      })
    })
  },

  _characteristics: function(address, service) {
    console.log('characteristics: ' + address + '(' + service + ')')

    return new Promise(function(resolve, reject) {
      bluetoothle.characteristics(resolve, reject, {
        address: address,
        service: service
      })
    })
  },

  _connect: function(address) {
    console.log('connect: ' + address)

    return new Promise(function(resolve, reject) {
      bluetoothle.connect(resolve, reject, { address: address })
    })
  },

  _write: function(address, serviceUuid, characteristic, value) {
    if (characteristic === 'undefined') {
      return Promise.reject('characteristic not found')
    } else if (!characteristic.properties.write) {
      return Promise.reject('characteristic is not write')
    }

    console.log('write: ' + address + '(' + value + ')')

    return new Promise(function(resolve, reject) {
      bluetoothle.write(resolve, reject, {
        address: address,
        service: serviceUuid,
        characteristic: characteristic.uuid,
        value: value,
        type: 'Response'
      })
    })
  },

  _read: function(address, serviceUuid, characteristic) {
    if (characteristic === 'undefined') {
      return Promise.reject('characteristic not found')
    } else if (!characteristic.properties.read) {
      return Promise.reject('characteristic is not read')
    }

    console.log('read: ' + address)

    return new Promise(function(resolve, reject) {
      bluetoothle.read(resolve, reject, {
        address: address,
        service: serviceUuid,
        characteristic: characteristic.uuid
      })
    })
  },

  _disconnect: function(address) {
    console.log('disconnect: ' + address)

    return new Promise(function(resolve, reject) {
      bluetoothle.disconnect(resolve, reject, { address: address })
    })
  },

  _close: function(address) {
    console.log('close: ' + address)

    return new Promise(function(resolve, reject) {
      bluetoothle.close(resolve, reject, { address: address })
    })
  },

  _subscribeSuccess: function(subscribed) {
    console.log('_subscribeSuccess():' + JSON.stringify(subscribed))
    if (subscribed.status == 'subscribed') {
      if (
        this._isNumber4Device(subscribed.address) &&
        subscribed.characteristic == '5D87A4A3-E42D-11E5-BEEF-0002A5D5C51B'
      ) {
        setTimeout(() => {
          this._writeNumber4Device(subscribed.address)
        }, 200)
      } else if (
        this._isNumber10Device(subscribed.address) &&
        subscribed.characteristic == '11127002-B364-11E4-AB27-0800200C9A66'
      ) {
        setTimeout(() => {
          this._writeNumber10Device(subscribed.address)
        }, 200)
      }
      return
    }

    var bytes = bluetoothle.encodedStringToBytes(subscribed.value)
    console.log(buf2hex(bytes))

    this.readVal.deviceType = -1
    this.readVal.bytes = ''
    this.readVal.datetime = ''
    this.readVal.invalid = false
    this.readVal.spo2 = ''
    this.readVal.pr = ''
    this.readVal.systolicPressure = ''
    this.readVal.diastolicPressure = ''
    this.readVal.temperature = ''
    this.readVal.measurementTime = ''
    this.readVal.ecg = ''
    this.readVal.trigger1 = ''
    this.readVal.trigger2 = ''
    this.readVal.heartRate = ''
    this.readVal.glucose = ''

    if (this._isNumber5Device(subscribed.address)) {
      this.readVal.deviceType = 5
      this.readVal.datetime = new Date()

      //データが正しいかの判定
      let isFullyQualified = bytes[5] & 0x80
      let isValidatedData = bytes[6] & 0x01
      if (!(isFullyQualified && isValidatedData)) {
        console.log('invalid data')
        this.readVal.invalid = true
      }

      let spo2Raw = new DataView(bytes.buffer, 1, 2)
      let prRaw = new DataView(bytes.buffer, 3, 2)
      let spo2 = readSFLOAT(spo2Raw, true)
      let pr = readSFLOAT(prRaw, true)
      console.log('spo2:' + spo2 + ', pr:' + pr)

      this.readVal.spo2 = spo2
      this.readVal.pr = pr
      this.readVal.bytes = bytes
    } else if (
      this._isNumber1Device(subscribed.address) ||
      this._isNumber2Device(subscribed.address)
    ) {
      if (this._isNumber1Device(subscribed.address)) {
        this.readVal.deviceType = 1
      } else {
        this.readVal.deviceType = 2
      }
      this.readVal.datetime = new Date()

      let isKPa = bytes[0] & 0b00000001
      let containsDateTime = bytes[0] & 0b00000010
      let containsPR = bytes[0] & 0b00000100
      let containsUserID = bytes[0] & 0b00001000
      let containsMeasurementStatus = bytes[0] & 0b00010000

      var index = 1

      if (isKPa) {
        let systolicPressureKPaRaw = new DataView(bytes.buffer, index, 2)
        index += 2
        let diastolicPressureKPaRRaw = new DataView(bytes.buffer, index, 2)
        index += 2
        index += 2 //mean
        let systolicPressure =
          readSFLOAT(systolicPressureKPaRRaw, true) * 7.50062
        let diastolicPressure =
          readSFLOAT(diastolicPressureKPaRRaw, true) * 7.50062
        console.log(
          'systolicPressure:' +
            systolicPressure +
            ', diastolicPressure:' +
            diastolicPressure
        )

        this.readVal.systolicPressure = systolicPressure
        this.readVal.diastolicPressure = diastolicPressure
      } else {
        let systolicPressureRaw = new DataView(bytes.buffer, index, 2)
        index += 2
        let diastolicPressureRaw = new DataView(bytes.buffer, index, 2)
        index += 2
        index += 2 //mean
        let systolicPressure = readSFLOAT(systolicPressureRaw, true)
        let diastolicPressure = readSFLOAT(diastolicPressureRaw, true)
        console.log(
          'systolicPressure:' +
            systolicPressure +
            ', diastolicPressure:' +
            diastolicPressure
        )

        this.readVal.systolicPressure = systolicPressure
        this.readVal.diastolicPressure = diastolicPressure
      }

      if (containsDateTime) {
        let dv = new DataView(bytes.buffer, 0, bytes.buffer.length)

        let year = dv.getUint16(index, true)
        index += 2
        let month = dv.getUint8(index++)
        let day = dv.getUint8(index++)
        let hour = dv.getUint8(index++)
        let minute = dv.getUint8(index++)
        let second = dv.getUint8(index++)
        console.log(
          year +
            '/' +
            month +
            '/' +
            day +
            ' ' +
            hour +
            ':' +
            minute +
            ':' +
            second
        )

        this.readVal.measurementTime = new Date(
          year,
          month - 1,
          day,
          hour,
          minute,
          second
        )
      }

      if (containsPR) {
        let pulseRateRaw = new DataView(bytes.buffer, index, 2)
        index += 2
        let pulseRate = readSFLOAT(pulseRateRaw, true)
        console.log('pulseRate:' + pulseRate)

        this.readVal.pr = pulseRate
      }

      //no1もno2も異常系は下記に当てはまる(MeasurementStatusは常に0x0000で使えない)
      if (
        this.readVal.systolicPressure == 2047 &&
        this.readVal.diastolicPressure == 2047 &&
        this.readVal.pr == 2047
      ) {
        console.log('invalid data')
        this.readVal.invalid = true
      }

      this.readVal.bytes = bytes
    } else if (
      this._isNumber3Device(subscribed.address) ||
      this._isNumber9Device(subscribed.address)
    ) {
      if (this._isNumber3Device(subscribed.address)) {
        this.readVal.deviceType = 3
      } else {
        this.readVal.deviceType = 9
      }
      this.readVal.datetime = new Date()

      let isFahrenheit = bytes[0] & 0b00000001
      let containsDateTime = bytes[0] & 0b00000010
      let type = bytes[0] & 0b00000100

      if (
        bytes[1] == 0xff &&
        bytes[2] == 0xff &&
        bytes[3] == 0x7f &&
        bytes[4] == 0x00
      ) {
        console.log('invalid data')
        this.readVal.invalid = true
      }

      if (isFahrenheit) {
        let fRaw = new DataView(bytes.buffer, 1, 4)
        let f = (readSFLOAT(fRaw, true) / 10).toFixed(1)
        let temperature = ((f - 32) / 1.8).toFixed(1)

        console.log('temperature:' + f + 'F->' + temperature + 'C')

        this.readVal.temperature = temperature
      } else {
        let temperatureRaw = new DataView(bytes.buffer, 1, 4)
        let temperature = (readSFLOAT(temperatureRaw, true) / 10).toFixed(1)
        console.log('temperature:' + temperature)

        this.readVal.temperature = temperature
      }

      if (containsDateTime) {
        let dv = new DataView(bytes.buffer, 0, bytes.buffer.length)

        let year = dv.getUint16(5, true)
        let month = dv.getUint8(7)
        let day = dv.getUint8(8)
        let hour = dv.getUint8(9)
        let minute = dv.getUint8(10)
        let second = dv.getUint8(11)
        console.log(
          year +
            '/' +
            month +
            '/' +
            day +
            ' ' +
            hour +
            ':' +
            minute +
            ':' +
            second
        )

        this.readVal.measurementTime = new Date(
          year,
          month - 1,
          day,
          hour,
          minute,
          second
        )
      }

      this.readVal.bytes = bytes
    } else if (this._isNumber6Device(subscribed.address)) {
      this.readVal.deviceType = 6
      this.readVal.datetime = new Date()

      if (subscribed.characteristic == 'C74D2000-457D-4194-8B37-E7188723AEA9') {
        //ecg
        let dv = new DataView(bytes.buffer, 0, bytes.buffer.length)

        var index = 0

        let dataSize = bytes[index] & 0b00111111
        let containsDateTime = bytes[index] & 0b01000000
        index++

        let counter = dv.getUint16(index, true)

        console.log('dataSize:' + dataSize + ' counter:' + counter)

        index = index + 2
        if (containsDateTime) {
          let year = dv.getUint8(index++) + 2000
          let month = dv.getUint8(index++)
          let day = dv.getUint8(index++)
          let hour = dv.getUint8(index++)
          let minute = dv.getUint8(index++)
          let second = dv.getUint8(index++)
          console.log(
            year +
              '/' +
              month +
              '/' +
              day +
              ' ' +
              hour +
              ':' +
              minute +
              ':' +
              second
          )

          this.readVal.measurementTime = new Date(
            year,
            month - 1,
            day,
            hour,
            minute,
            second
          )
        }

        let trigger1 = dv.getUint8(index++)
        let trigger2 = dv.getUint8(index++)

        console.log(
          'counter:' +
            counter +
            ' trigger1:' +
            trigger1 +
            ' trigger2:' +
            trigger2
        )

        let rawEcg = Huffman.decode(bytes.slice(index), dataSize)
        if (!this._noiseFilter) {
          this._noiseFilter = new HumNoiseFilter()
        }
        let noiseFilter = this._noiseFilter
        let ecg = rawEcg.map(function(value, index, array) {
          return noiseFilter.apply((value - 512) * 0.01)
        })
        console.log('ecg:' + JSON.stringify(ecg))

        this.readVal.trigger1 = trigger1
        this.readVal.trigger2 = trigger2
        this.readVal.ecg = ecg
        this.readVal.bytes = bytes
      } else if (
        subscribed.characteristic == 'C74D2002-457D-4194-8B37-E7188723AEA9'
      ) {
        //hr
        let dv = new DataView(bytes.buffer, 0, bytes.buffer.length)

        var index = 0

        let containsDateTime = bytes[index] & 0b00010000
        let isLeadsOffDetect = bytes[index] & 0b00100000
        let isIllegalDevice = bytes[index] & 0b01000000
        index++

        console.log(
          'isLeadsOffDetect:' +
            isLeadsOffDetect +
            ' isIllegalDevice:' +
            isIllegalDevice
        )

        if (containsDateTime) {
          let year = dv.getUint8(index++) + 2000
          let month = dv.getUint8(index++)
          let day = dv.getUint8(index++)
          let hour = dv.getUint8(index++)
          let minute = dv.getUint8(index++)
          let second = dv.getUint8(index++)
          console.log(
            year +
              '/' +
              month +
              '/' +
              day +
              ' ' +
              hour +
              ':' +
              minute +
              ':' +
              second
          )

          this.readVal.measurementTime = new Date(
            year,
            month - 1,
            day,
            hour,
            minute,
            second
          )
        }

        let heartRate = dv.getUint8(index++)
        let hrResponseInterval = dv.getUint8(index++)
        console.log(
          'heartRate:' + heartRate + ' hrResponseInterval:' + hrResponseInterval
        )

        this.readVal.heartRate = heartRate
        this.readVal.bytes = bytes
      }
    } else if (this._isNumber7Device(subscribed.address)) {
      this.readVal.deviceType = 7
      this.readVal.datetime = new Date()

      let containsDateTime = bytes[0] & 0b00000001
      if (bytes[1] & 0b00001111) {
        console.log('invalid data')
        this.readVal.invalid = true
      }

      let dv = new DataView(bytes.buffer, 0, bytes.buffer.length)

      let spo2 = dv.getUint16(2, true)
      let pr = dv.getUint16(4, true)
      console.log('spo2:' + spo2 + ' pr:' + pr)

      if (bytes[2] == 0x7f && bytes[3] == 0xff) {
        console.log('spo2 measuring')
        this.readVal.invalid = true
      }
      this.readVal.spo2 = spo2

      if (bytes[4] == 0xff && bytes[5] == 0xff) {
        console.log('pr measuring')
        this.readVal.invalid = true
      }
      this.readVal.pr = pr

      if (containsDateTime) {
        let year = dv.getUint16(6, true)
        let month = dv.getUint8(8)
        let day = dv.getUint8(9)
        let hour = dv.getUint8(10)
        let minute = dv.getUint8(11)
        let second = dv.getUint8(12)
        console.log(
          year +
            '/' +
            month +
            '/' +
            day +
            ' ' +
            hour +
            ':' +
            minute +
            ':' +
            second
        )

        this.readVal.measurementTime = new Date(
          year,
          month - 1,
          day,
          hour,
          minute,
          second
        )
      }

      this.readVal.bytes = bytes
    } else if (this._isNumber4Device(subscribed.address)) {
      this.readVal.deviceType = 4
      this.readVal.datetime = new Date()

      if (subscribed.characteristic == '5D87A4A1-E42D-11E5-BEEF-0002A5D5C51B') {
        let isTimeOffsetPresent = bytes[0] & 0b00000001
        let isNormalMeasurement = bytes[0] & 0b00000010
        let isUnitMol = bytes[0] & 0b00000100
        let isSensorStatusNg = bytes[0] & 0b00001000

        if (isSensorStatusNg) {
          console.log('invalid data')
          this.readVal.invalid = true
        }

        let sequenceNumberRaw = new DataView(bytes.buffer, 1, 2)
        let sequenceNumber = readSFLOAT(sequenceNumberRaw, true)

        let dv = new DataView(bytes.buffer, 0, bytes.buffer.length)
        let year = dv.getUint16(3, true)
        let month = dv.getUint8(5)
        let day = dv.getUint8(6)
        let hour = dv.getUint8(7)
        let minute = dv.getUint8(8)
        let second = dv.getUint8(9)
        console.log(
          year +
            '/' +
            month +
            '/' +
            day +
            ' ' +
            hour +
            ':' +
            minute +
            ':' +
            second
        )

        this.readVal.measurementTime = new Date(
          year,
          month - 1,
          day,
          hour,
          minute,
          second
        )

        let glucoseRaw = new DataView(bytes.buffer, 12, 2)
        let glucose = readSFLOAT(glucoseRaw, true)
        if (isUnitMol) {
          //mol/L -> mmol/L
          glucose = glucose * 1000
          //mmol/L　→　mg/dL
          glucose = glucose * 18
        } else {
          //kg/L -> mg/dL
          glucose = Math.round(glucose * 100000)
        }

        console.log('glucose:' + glucose)

        this.readVal.glucose = glucose

        this.readVal.bytes = bytes
      } else if (
        subscribed.characteristic == '5D87A4A3-E42D-11E5-BEEF-0002A5D5C51B'
      ) {
        console.log('---')
      }
    } else if (this._isNumber10Device(subscribed.address)) {
      this.readVal.deviceType = 10
      this.readVal.datetime = new Date()

      if (subscribed.characteristic == '2A9D') {
        this.readVal.weight = ''
        this.readVal.measurementTime = ''

        let isImperial = bytes[0] & 0b00000001
        let containsDateTime = bytes[0] & 0b00000010

        if (bytes[1] == 0xff && bytes[2] == 0xff) {
          console.log('invalid data')
          return
        }

        let dv = new DataView(bytes.buffer, 0, bytes.buffer.length)
        if (isImperial) {
          let imperialWeight = dv.getUint16(1, true) * 0.01
          let weight =
            Math.round(imperialWeight * 0.45359293319936 * 1000) / 1000
          console.log('weight:' + weight)

          this.readVal.weight = weight
        } else {
          let weight = Math.round(dv.getUint16(1, true) * 0.005 * 1000) / 1000
          console.log('weight:' + weight)

          this.readVal.weight = weight
        }

        if (containsDateTime) {
          let year = dv.getUint16(3, true)
          let month = dv.getUint8(5)
          let day = dv.getUint8(6)
          let hour = dv.getUint8(7)
          let minute = dv.getUint8(8)
          let second = dv.getUint8(9)
          console.log(
            year +
              '/' +
              month +
              '/' +
              day +
              ' ' +
              hour +
              ':' +
              minute +
              ':' +
              second
          )

          this.readVal.measurementTime = new Date(
            year,
            month,
            day,
            hour,
            minute,
            second
          )
        }

        this.readVal.bytes = bytes
      } else if (subscribed.characteristic == '2A9C') {
        //体重以外を取得するコード(動作は未確認)
        this.readVal.bodyFat = ''
        this.readVal.measurementTime = ''
        this.readVal.basalMetabolism = ''
        this.readVal.muscleMass = ''
        this.readVal.bodyWaterMass = ''

        let isImperial = bytes[0] & 0b00000001
        let containsDateTime = bytes[0] & 0b00000010
        let containsUserID = bytes[0] & 0b00000100 //true
        let containsBasalMetabolism = bytes[0] & 0b00001000 //true
        let containsMusclePercentage = bytes[0] & 0b00010000 //false
        let containsMuscleMass = bytes[0] & 0b00100000 //true
        let containsFatFreeMass = bytes[0] & 0b01000000 //false
        let containsSoftLeanMass = bytes[0] & 0b10000000 //false
        let containsBodyWaterMass = bytes[1] & 0b00000001 //true
        let containsImpedance = bytes[1] & 0b00000010 //true
        let containsWeight = bytes[1] & 0b00000100 //false
        let containsHeight = bytes[1] & 0b00001000 //false
        let containsMultiple = bytes[1] & 0b00010000 //false

        let dv = new DataView(bytes.buffer, 0, bytes.buffer.length)
        var index = 1

        let bodyFat = dv.getUint16(index, true) * 0.1
        if (bodyFat == 65535) {
          console.log('invalid data')
          return
        }
        index += 2
        this.readVal.bodyFat = bodyFat

        if (containsDateTime) {
          let year = dv.getUint16(index, true)
          index += 2
          let month = dv.getUint8(index++)
          let day = dv.getUint8(index++)
          let hour = dv.getUint8(index++)
          let minute = dv.getUint8(index++)
          let second = dv.getUint8(index++)
          console.log(
            year +
              '/' +
              month +
              '/' +
              day +
              ' ' +
              hour +
              ':' +
              minute +
              ':' +
              second
          )

          this.readVal.measurementTime = new Date(
            year,
            month,
            day,
            hour,
            minute,
            second
          )
        }

        if (containsUserID) {
          index++
        }

        if (containsBasalMetabolism) {
          let basalMetabolism = dv.getUint16(index, true)
          if (basalMetabolism == 65535) {
            console.log('invalid data')
            return
          }
          index += 2

          this.readVal.basalMetabolism = basalMetabolism
        }

        if (containsMuscleMass) {
          if (isImperial) {
            let imperialMuscleMassRaw = dv.getUint16(index, true)
            if (imperialMuscleMassRaw == 65535) {
              console.log('invalid data')
              return
            }
            let imperialMuscleMass = imperialMuscleMassRaw * 0.01
            index += 2
            let muscleMass =
              Math.round(imperialMuscleMass * 0.45359293319936 * 1000) / 1000
            console.log('muscleMass:' + muscleMass)

            this.readVal.muscleMass = muscleMass
          } else {
            let muscleMassRaw = dv.getUint16(index, true)
            if (muscleMassRaw == 65535) {
              console.log('invalid data')
              return
            }
            let muscleMass = muscleMassRaw * 0.005
            index += 2
            console.log('muscleMass:' + muscleMass)

            this.readVal.muscleMass = muscleMass
          }
        }

        if (containsBodyWaterMass) {
          if (isImperial) {
            let imperialBodyWaterMassRaw = dv.getUint16(index, true)
            if (imperialBodyWaterMassRaw == 65535) {
              console.log('invalid data')
              return
            }
            let imperialBodyWaterMass = imperialBodyWaterMassRaw * 0.01
            index += 2
            let bodyWaterMass =
              Math.round(imperialBodyWaterMass * 0.45359 * 1000) / 1000
            console.log('bodyWaterMass:' + bodyWaterMass)

            this.readVal.bodyWaterMass = bodyWaterMass
          } else {
            let bodyWaterMassRaw = dv.getUint16(index, true)
            if (bodyWaterMassRaw == 65535) {
              console.log('invalid data')
              return
            }
            let bodyWaterMass = bodyWaterMassRaw * 0.005
            index += 2
            console.log('bodyWaterMass:' + bodyWaterMass)

            this.readVal.bodyWaterMass = bodyWaterMass
          }
        }

        this.readVal.bytes = bytes
      } else if (subscribed.characteristic == '181C') {
        console.log('---')
      }
    }
    this.onChangeReadVal()

    if (this.readVal.bytes == '') {
      return
    }

    let listener = this._receivedValueListener[subscribed.address]
    if (listener === undefined) {
      return
    }
    listener(this.readVal)
  },

  _writeNumber4Device: function(address) {
    console.log('Current Time')

    let buffer = new Uint8Array([255, 255, 255, 255, 255, 255, 255]).buffer
    let dataView = new DataView(buffer)

    const date = new Date()
    dataView.setUint16(0, date.getFullYear(), true)
    dataView.setUint8(2, date.getMonth() + 1)
    dataView.setUint8(3, date.getDate())
    dataView.setUint8(4, date.getHours())
    dataView.setUint8(5, date.getMinutes())
    dataView.setUint8(6, date.getSeconds())

    console.log(buf2hex(dataView.buffer))

    var value = bluetoothle.bytesToEncodedString(
      new Uint8Array(dataView.buffer)
    )
    new Promise(function(resolve, reject) {
      bluetoothle.write(resolve, reject, {
        address: address,
        service: '87F60001-A469-1EF4-637F-78B96A6F358B',
        characteristic: '87F60002-A469-1EF4-637F-78B96A6F358B',
        value: value,
        type: 'Response'
      })
    })
      .then(() => {
        console.log('remoteDeviceInformationCharacteristic')

        let buffer = new Uint8Array([255, 255]).buffer
        let dataView = new DataView(buffer)

        dataView.setUint8(0, 0) //Device Category
        dataView.setUint8(1, 1) //Device Property

        console.log(buf2hex(dataView.buffer))

        var value = bluetoothle.bytesToEncodedString(
          new Uint8Array(dataView.buffer)
        )

        return new Promise(function(resolve, reject) {
          bluetoothle.write(resolve, reject, {
            address: address,
            service: '7A1A0001-8D7F-1727-A23F-DEDB5BF5DF46',
            characteristic: '7A1A0003-8D7F-1727-A23F-DEDB5BF5DF46',
            value: value,
            type: 'Response'
          })
        })
      })
      .then(() => {
        console.log('recordAccessControlPointCharacteristic0')

        let buffer = new Uint8Array([255, 255]).buffer
        let dataView = new DataView(buffer)

        dataView.setUint8(0, 1) //Number of stored records
        dataView.setUint8(1, 1) //All records

        console.log(buf2hex(dataView.buffer))

        var value = bluetoothle.bytesToEncodedString(
          new Uint8Array(dataView.buffer)
        )

        return new Promise(function(resolve, reject) {
          bluetoothle.write(resolve, reject, {
            address: address,
            service: '5D87A4A0-E42D-11E5-BEEF-0002A5D5C51B',
            characteristic: '5D87A4A3-E42D-11E5-BEEF-0002A5D5C51B',
            value: value,
            type: 'Response'
          })
        })
      })
      .catch(error => {
        console.log('catch ' + JSON.stringify(error))
        if (this._disconnecting) {
          return
        }
        this._connectError(error)
      })
  },

  _writeNumber10Device: function(address) {
    console.log('Custom')

    var buffer = new Uint8Array([0x04, 0x01, 0x14, 0x13, 0x01]).buffer
    let dataView = new DataView(buffer)

    console.log(buf2hex(dataView.buffer))

    var value = bluetoothle.bytesToEncodedString(
      new Uint8Array(dataView.buffer)
    )
    new Promise(function(resolve, reject) {
      bluetoothle.write(resolve, reject, {
        address: address,
        service: '11127000-B364-11E4-AB27-0800200C9A66',
        characteristic: '11127001-B364-11E4-AB27-0800200C9A66',
        value: value,
        type: 'Response'
      })
    })
      .then(() => {
        if (this._userControl == 'add') {
          console.log('User Control Point add')
          var buffer = new Uint8Array([0x01, 0x00, 0x00]).buffer
          let dataView = new DataView(buffer)

          console.log(buf2hex(dataView.buffer))

          var value = bluetoothle.bytesToEncodedString(
            new Uint8Array(dataView.buffer)
          )
          return new Promise(function(resolve, reject) {
            bluetoothle.write(resolve, reject, {
              address: address,
              service: '181C',
              characteristic: '2A9F',
              value: value,
              type: 'Response'
            })
          })
        }
      })
      .then(() => {
        if (this._userControl == 'add') {
          console.log('User Control Point auth')
          var buffer = new Uint8Array([0x02, 0x01, 0x00, 0x00]).buffer
          let dataView = new DataView(buffer)

          console.log(buf2hex(dataView.buffer))

          var value = bluetoothle.bytesToEncodedString(
            new Uint8Array(dataView.buffer)
          )
          return new Promise(function(resolve, reject) {
            bluetoothle.write(resolve, reject, {
              address: address,
              service: '181C',
              characteristic: '2A9F',
              value: value,
              type: 'Response'
            })
          })
        }
      })
      .catch(error => {
        console.log('catch ' + JSON.stringify(error))
        if (this._disconnecting) {
          return
        }
        this._connectError(error)
      })
  },

  _isNumber5Device: function(address) {
    return this._containsFoundDevices(address, 'MightySat')
  },

  _isNumber1Device: function(address) {
    return (
      this._containsFoundDevices(address, 'A&D_UA-651BLE') ||
      this._containsFoundDevices(address, 'NBP-1BLE')
    )
  },

  _isNumber3Device: function(address) {
    return this._containsFoundDevices(address, 'NSM-1BLE')
  },

  _isNumber6Device: function(address) {
    return this._containsFoundDevices(address, 'NC')
  },

  _isNumber7Device: function(address) {
    return this._containsFoundDevices(address, 'TM1121')
  },

  _isNumber2Device: function(address) {
    return this._containsFoundDevices(address, 'NMBP')
  },

  _isNumber9Device: function(address) {
    return this._containsFoundDevices(address, 'NT-100B')
  },

  _isNumber4Device: function(address) {
    return this._containsFoundDevices(address, 'NIPRO CF')
  },

  _isNumber10Device: function(address) {
    return (
      this._containsFoundDevices(address, 'NBCM') ||
      this._containsFoundDevices(address, 'UC-421BLE')
    )
  },

  _containsFoundDevices: function(address, prefixName) {
    var found = false
    this._foundAllDevices.forEach((element, index) => {
      if (
        element.address == address &&
        element.name.indexOf(prefixName) === 0
      ) {
        found = true
      }
    })
    return found
  }
}

class NotchFilter {
  constructor(dFc) {
    this.m_dFc = dFc
    this.m_dX1 = 0
    this.m_dX2 = 0
    this.m_dY1 = 0
    this.m_dY2 = 0
  }

  apply(dX0) {
    const PI = Math.PI
    const Q = 50
    const Fs = 125

    let k1 = 1 / (1 + Math.sin((2 * Math.PI * this.m_dFc) / Fs / (2 * Q)))
    let k2 =
      (-2 * Math.cos((2 * PI * this.m_dFc) / Fs)) /
      (1 + Math.sin((2 * PI * this.m_dFc) / Fs / (2 * Q)))
    let k3 = 1 / (1 + Math.sin((2 * PI * this.m_dFc) / Fs / (2 * Q)))
    let k4 =
      (-2 * Math.cos((2 * PI * this.m_dFc) / Fs)) /
      (1 + Math.sin((2 * PI * this.m_dFc) / Fs / (2 * Q)))
    let k5 =
      (1 - Math.sin((2 * PI * this.m_dFc) / Fs / (2 * Q))) /
      (1 + Math.sin((2 * PI * this.m_dFc) / Fs / (2 * Q)))
    let dY0 =
      k1 * dX0 +
      k2 * this.m_dX1 +
      k3 * this.m_dX2 -
      k4 * this.m_dY1 -
      k5 * this.m_dY2
    this.m_dX2 = this.m_dX1
    this.m_dX1 = dX0
    this.m_dY2 = this.m_dY1
    this.m_dY1 = dY0
    return dY0
  }
}

class HumNoiseFilter {
  constructor() {
    this.filter50 = new NotchFilter(50)
    this.filter60 = new NotchFilter(60)
  }

  apply(dX0) {
    return this.filter60.apply(this.filter50.apply(dX0))
  }
}

function buf2hex(buffer) {
  return Array.prototype.map
    .call(new Uint8Array(buffer), x => ('00' + x.toString(16)).slice(-2))
    .join('')
}

//see https://qiita.com/megadreams14/items/1c88e71d87970bc8ab90
/*
 * IEEE-11073 16-bit SFLOAT型をバイナリから取得し実数に変換する
 *
 * @param dv:DataView   16ビットのバイナリデータ
 * @param littleEndian  バイトオーダーの扱い(デフォルトは、fakse = ビッグエンディアン方式：)
 */
function readSFLOAT(dv, littleEndian = false) {
  // 1. バイトオーダーを指定して16ビットデータを取得
  var data = dv.getUint16(0, littleEndian)

  // 2. 仮数部を取得する(16ビットの場合は下位12ビットが仮数部)
  //    - 取得した16ビットデータに下位12ビットの全てのフラグを立てた値を掛け算することで取得
  var mantissa = data & 0x0fff

  // 仮数部も2の補数で判定するため16ビットのうちの12ビット中の上位1桁がマイナスを表していないかを確認
  if ((mantissa & 0x0800) > 0) {
    // もしマイナス値の場合は、1を引いた後反転処理と12ビット分の論理和を取得する)
    mantissa = -1 * (~(mantissa - 0x01) & 0x0fff)
  }

  // 3. 指数部を取得する(16ビットの場合は上位4ビットが指数部)
  // 上位4ビットを取得するためには16ビットの場合右へ12ビットシフトさせると取得可能
  var exponential = data >> 12

  if ((exponential & 0b1000) > 0) {
    exponential = -1 * (~(exponential - 0b0001) & 0b1111)
  }

  // 「仮数部 × 基数部 ^ 指数部」の公式に当てはめて変換
  return mantissa * Math.pow(10, exponential)
}

//Huffman
let END_OF_BUFFER = -1

var num_nodes = 0
var bits_in_buffer = 0
var current_bit = 0
var eof_buffer = false

var Huffman = {
  decode: function(buffer, size) {
    num_nodes = 0
    bits_in_buffer = 0
    current_bit = 0
    eof_buffer = false

    var dec = this._decode_bit_stream(buffer, size)

    dec[0] = dec[0] > 1023 ? dec[0] - 2048 : dec[0]
    for (j = 1; j < dec.length; j++) {
      dec[j] = dec[j - 1] + (dec[j] > 1023 ? dec[j] - 2048 : dec[j])
    }

    return dec
  },

  _read_node: function() {
    num_nodes = nodeIndex.length
  },

  _decode_bit_stream: function(encoded_data, original_size) {
    var decoded_buffer = Array(original_size)
    decoded_buffer.fill(0)
    var cnt_datasize = 0
    var bit = 0
    var node_index = 0

    this._read_node()
    node_index = nodeIndex[num_nodes - 1]

    eof_buffer = false
    current_bit = 0
    bits_in_buffer = 0
    while (true) {
      bit = this._read_bit(encoded_data)

      if (bit == END_OF_BUFFER) {
        break
      }

      node_index = nodeIndex[node_index * 2 - bit]
      if (node_index < 0) {
        decoded_buffer[cnt_datasize] = -node_index - 1

        cnt_datasize = cnt_datasize + 1
        if (cnt_datasize == original_size) {
          break
        }

        node_index = nodeIndex[num_nodes - 1]
      }
    }
    return decoded_buffer
  },

  _read_bit: function(buffer) {
    if (current_bit == bits_in_buffer) {
      if (eof_buffer) {
        return END_OF_BUFFER
      } else {
        eof_buffer = true
        bits_in_buffer = buffer.length << 3
        current_bit = 0
      }
    }

    if (bits_in_buffer == 0) {
      return END_OF_BUFFER
    }

    let bit = (buffer[current_bit >> 3] >> (7 - (current_bit % 8))) & 0x1
    current_bit = current_bit + 1

    return bit
  }
}

let nodeIndex = [
  0,
  -227,
  -228,
  -229,
  -230,
  -231,
  -232,
  -233,
  -234,
  -235,
  -236,
  -237,
  -238,
  -239,
  -240,
  -241,
  -242,
  -243,
  -244,
  -245,
  -246,
  -247,
  -248,
  -249,
  -250,
  -251,
  -252,
  -253,
  -254,
  -255,
  -256,
  -257,
  -258,
  -259,
  -260,
  -261,
  -262,
  -263,
  -264,
  -265,
  -266,
  -267,
  -268,
  -269,
  -270,
  -271,
  -272,
  -273,
  -274,
  -275,
  -276,
  -277,
  -278,
  -279,
  -280,
  -281,
  -282,
  -283,
  -284,
  -285,
  -286,
  -287,
  -288,
  -289,
  -290,
  -291,
  -292,
  -293,
  -294,
  -295,
  -296,
  -297,
  -298,
  -299,
  -300,
  -301,
  -302,
  -303,
  -304,
  -305,
  -306,
  -307,
  -308,
  -309,
  -310,
  -311,
  -312,
  -313,
  -314,
  -315,
  -316,
  -317,
  -318,
  -319,
  -320,
  -321,
  -322,
  -323,
  -324,
  -325,
  -326,
  -327,
  -328,
  -329,
  -330,
  -331,
  -332,
  -333,
  -334,
  -335,
  -336,
  -337,
  -338,
  -339,
  -340,
  -341,
  -342,
  -343,
  -344,
  -345,
  -346,
  -347,
  -348,
  -349,
  -350,
  -351,
  -352,
  -353,
  -354,
  -355,
  -356,
  -357,
  -358,
  -359,
  -360,
  -361,
  -362,
  -363,
  -364,
  -365,
  -366,
  -367,
  -368,
  -369,
  -370,
  -371,
  -372,
  -373,
  -374,
  -375,
  -376,
  -377,
  -378,
  -379,
  -380,
  -381,
  -382,
  -383,
  -384,
  -385,
  -386,
  -387,
  -388,
  -389,
  -390,
  -391,
  -392,
  -393,
  -394,
  -395,
  -396,
  -397,
  -398,
  -399,
  -400,
  -401,
  -402,
  -403,
  -404,
  -405,
  -406,
  -407,
  -408,
  -409,
  -410,
  -411,
  -412,
  -413,
  -414,
  -415,
  -416,
  -417,
  -418,
  -419,
  -420,
  -421,
  -422,
  -423,
  -424,
  -425,
  -426,
  -427,
  -428,
  -429,
  -430,
  -431,
  -432,
  -433,
  -434,
  -435,
  -436,
  -437,
  -438,
  -439,
  -440,
  -441,
  -442,
  -443,
  -444,
  -445,
  -446,
  -447,
  -448,
  -449,
  -450,
  -451,
  -452,
  -453,
  -454,
  -455,
  -456,
  -457,
  -458,
  -459,
  -460,
  -461,
  -462,
  -463,
  -464,
  -465,
  -466,
  -467,
  -468,
  -469,
  -470,
  -471,
  -472,
  -473,
  -474,
  -475,
  -476,
  -477,
  -478,
  -479,
  -480,
  -481,
  -482,
  -483,
  -484,
  -485,
  -486,
  -487,
  -488,
  -489,
  -490,
  -491,
  -492,
  -493,
  -494,
  -495,
  -496,
  -497,
  -498,
  -499,
  -500,
  -501,
  -502,
  -503,
  -504,
  -505,
  -506,
  -507,
  -508,
  -509,
  -510,
  -511,
  -512,
  -513,
  -514,
  -515,
  -516,
  -517,
  -518,
  -519,
  -520,
  -521,
  -522,
  -523,
  -524,
  -525,
  -526,
  -527,
  -528,
  -529,
  -530,
  -531,
  -532,
  -533,
  -534,
  -535,
  -536,
  -537,
  -538,
  -539,
  -540,
  -541,
  -542,
  -543,
  -544,
  -545,
  -546,
  -547,
  -548,
  -549,
  -550,
  -551,
  -552,
  -553,
  -554,
  -555,
  -556,
  -557,
  -558,
  -559,
  -560,
  -561,
  -562,
  -563,
  -564,
  -565,
  -566,
  -567,
  -568,
  -569,
  -570,
  -571,
  -572,
  -573,
  -574,
  -575,
  -576,
  -577,
  -578,
  -579,
  -580,
  -581,
  -582,
  -583,
  -584,
  -585,
  -586,
  -587,
  -588,
  -589,
  -590,
  -591,
  -592,
  -593,
  -594,
  -595,
  -596,
  -597,
  -598,
  -599,
  -600,
  -601,
  -602,
  -603,
  -604,
  -605,
  -606,
  -607,
  -608,
  -609,
  -610,
  -611,
  -612,
  -613,
  -614,
  -615,
  -616,
  -617,
  -618,
  -619,
  -620,
  -621,
  -622,
  -623,
  -624,
  -625,
  -626,
  -627,
  -628,
  -629,
  -630,
  -631,
  -632,
  -633,
  -634,
  -635,
  -636,
  -637,
  -638,
  -639,
  -640,
  -641,
  -642,
  -643,
  -644,
  -645,
  -646,
  -647,
  -648,
  -649,
  -650,
  -651,
  -652,
  -653,
  -654,
  -655,
  -656,
  -657,
  -658,
  -659,
  -660,
  -661,
  -662,
  -663,
  -664,
  -665,
  -666,
  -667,
  -668,
  -669,
  -670,
  -671,
  -672,
  -673,
  -674,
  -675,
  -676,
  -677,
  -678,
  -679,
  -680,
  -681,
  -682,
  -683,
  -684,
  -685,
  -686,
  -687,
  -688,
  -689,
  -690,
  -691,
  -692,
  -693,
  -694,
  -695,
  -696,
  -697,
  -698,
  -699,
  -700,
  -701,
  -702,
  -703,
  -704,
  -705,
  -706,
  -707,
  -708,
  -709,
  -710,
  -711,
  -712,
  -713,
  -714,
  -715,
  -716,
  -717,
  -718,
  -719,
  -720,
  -721,
  -722,
  -723,
  -724,
  -725,
  -726,
  -727,
  -728,
  -729,
  -730,
  -731,
  -732,
  -733,
  -734,
  -735,
  -736,
  -737,
  -738,
  -739,
  -740,
  -741,
  -742,
  -743,
  -744,
  -745,
  -746,
  -747,
  -748,
  -749,
  -750,
  -751,
  -752,
  -753,
  -754,
  -755,
  -756,
  -757,
  -758,
  -759,
  -760,
  -761,
  -762,
  -763,
  -764,
  -765,
  -766,
  -767,
  -768,
  -769,
  -770,
  -771,
  -772,
  -773,
  -774,
  -775,
  -776,
  -777,
  -778,
  -779,
  -780,
  -781,
  -782,
  -783,
  -784,
  -785,
  -786,
  -787,
  -788,
  -789,
  -790,
  -791,
  -792,
  -793,
  -794,
  -795,
  -796,
  -797,
  -798,
  -799,
  -800,
  -801,
  -802,
  -803,
  -804,
  -805,
  -806,
  -807,
  -808,
  -809,
  -810,
  -811,
  -812,
  -813,
  -814,
  -815,
  -816,
  -817,
  -818,
  -819,
  -820,
  -821,
  -822,
  -823,
  -824,
  -825,
  -826,
  -827,
  -828,
  -829,
  -830,
  -831,
  -832,
  -833,
  -834,
  -835,
  -836,
  -837,
  -838,
  -839,
  -840,
  -841,
  -842,
  -843,
  -844,
  -845,
  -846,
  -847,
  -848,
  -849,
  -850,
  -851,
  -852,
  -853,
  -854,
  -855,
  -856,
  -857,
  -858,
  -859,
  -860,
  -861,
  -862,
  -863,
  -864,
  -865,
  -866,
  -867,
  -868,
  -869,
  -870,
  -871,
  -872,
  -873,
  -874,
  -875,
  -876,
  -877,
  -878,
  -879,
  -880,
  -881,
  -882,
  -883,
  -884,
  -885,
  -886,
  -887,
  -888,
  -889,
  -890,
  -891,
  -892,
  -893,
  -894,
  -895,
  -896,
  -897,
  -898,
  -899,
  -900,
  -901,
  -902,
  -903,
  -904,
  -905,
  -906,
  -907,
  -908,
  -909,
  -910,
  -911,
  -912,
  -913,
  -914,
  -915,
  -916,
  -917,
  -918,
  -919,
  -920,
  -921,
  -922,
  -923,
  -924,
  -925,
  -926,
  -927,
  -928,
  -929,
  -930,
  -931,
  -932,
  -933,
  -934,
  -935,
  -936,
  -937,
  -938,
  -939,
  -940,
  -941,
  -942,
  -943,
  -944,
  -945,
  -946,
  -947,
  -948,
  -949,
  -950,
  -951,
  -952,
  -953,
  -954,
  -955,
  -956,
  -957,
  -958,
  -959,
  -960,
  -961,
  -962,
  -963,
  -964,
  -965,
  -966,
  -967,
  -968,
  -969,
  -970,
  -971,
  -972,
  -973,
  -974,
  -975,
  -976,
  -977,
  -978,
  -979,
  -980,
  -981,
  -982,
  -983,
  -984,
  -985,
  -986,
  -987,
  -988,
  -989,
  -990,
  -991,
  -992,
  -993,
  -994,
  -995,
  -996,
  -997,
  -998,
  -999,
  -1000,
  -1001,
  -1002,
  -1003,
  -1004,
  -1005,
  -1006,
  -1007,
  -1008,
  -1009,
  -1010,
  -1011,
  -1012,
  -1013,
  -1014,
  -1015,
  -1016,
  -1017,
  -1018,
  -1019,
  -1020,
  -1021,
  -1022,
  -1023,
  -1024,
  -1025,
  -1026,
  -1027,
  -1028,
  -1029,
  -1030,
  -1031,
  -1032,
  -1033,
  -1034,
  -1035,
  -1036,
  -1037,
  -1038,
  -1039,
  -1040,
  -1041,
  -1042,
  -1043,
  -1044,
  -1045,
  -1046,
  -1047,
  -1048,
  -1049,
  -1050,
  -1051,
  -1052,
  -1053,
  -1054,
  -1055,
  -1056,
  -1057,
  -1058,
  -1059,
  -1060,
  -1061,
  -1062,
  -1063,
  -1064,
  -1065,
  -1066,
  -1067,
  -1068,
  -1069,
  -1070,
  -1071,
  -1072,
  -1073,
  -1074,
  -1075,
  -1076,
  -1077,
  -1078,
  -1079,
  -1080,
  -1081,
  -1082,
  -1083,
  -1084,
  -1085,
  -1086,
  -1087,
  -1088,
  -1089,
  -1090,
  -1091,
  -1092,
  -1093,
  -1094,
  -1095,
  -1096,
  -1097,
  -1098,
  -1099,
  -1100,
  -1101,
  -1102,
  -1103,
  -1104,
  -1105,
  -1106,
  -1107,
  -1108,
  -1109,
  -1110,
  -1111,
  -1112,
  -1113,
  -1114,
  -1115,
  -1116,
  -1117,
  -1118,
  -1119,
  -1120,
  -1121,
  -1122,
  -1123,
  -1124,
  -1125,
  -1126,
  -1127,
  -1128,
  -1129,
  -1130,
  -1131,
  -1132,
  -1133,
  -1134,
  -1135,
  -1136,
  -1137,
  -1138,
  -1139,
  -1140,
  -1141,
  -1142,
  -1143,
  -1144,
  -1145,
  -1146,
  -1147,
  -1148,
  -1149,
  -1150,
  -1151,
  -1152,
  -1153,
  -1154,
  -1155,
  -1156,
  -1157,
  -1158,
  -1159,
  -1160,
  -1161,
  -1162,
  -1163,
  -1164,
  -1165,
  -1166,
  -1167,
  -1168,
  -1169,
  -1170,
  -1171,
  -1172,
  -1173,
  -1174,
  -1175,
  -1176,
  -1177,
  -1178,
  -1179,
  -1180,
  -1181,
  -1182,
  -1183,
  -1184,
  -1185,
  -1186,
  -1187,
  -1188,
  -1189,
  -1190,
  -1191,
  -1192,
  -1193,
  -1194,
  -1195,
  -1196,
  -1197,
  -1198,
  -1199,
  -1200,
  -1201,
  -1202,
  -1203,
  -1204,
  -1205,
  -1206,
  -1207,
  -1208,
  -1209,
  -1210,
  -1211,
  -1212,
  -1213,
  -1214,
  -1215,
  -1216,
  -1217,
  -1218,
  -1219,
  -1220,
  -1221,
  -1222,
  -1223,
  -1224,
  -1225,
  -1226,
  -1227,
  -1228,
  -1229,
  -1230,
  -1231,
  -1232,
  -1233,
  -1234,
  -1235,
  -1236,
  -1237,
  -1238,
  -1239,
  -1240,
  -1241,
  -1242,
  -1243,
  -1244,
  -1245,
  -1246,
  -1247,
  -1248,
  -1249,
  -1250,
  -1251,
  -1252,
  -1253,
  -1254,
  -1255,
  -1256,
  -1257,
  -1258,
  -1259,
  -1260,
  -1261,
  -1262,
  -1263,
  -1264,
  -1265,
  -1266,
  -1267,
  -1268,
  -1269,
  -1270,
  -1271,
  -1272,
  -1273,
  -1274,
  -1275,
  -1276,
  -1277,
  -1278,
  -1279,
  -1280,
  -1281,
  -1282,
  -1283,
  -1284,
  -1285,
  -1286,
  -1287,
  -1288,
  -1289,
  -1290,
  -1291,
  -1292,
  -1293,
  -1294,
  -1295,
  -1296,
  -1297,
  -1298,
  -1299,
  -1300,
  -1301,
  -1302,
  -1303,
  -1304,
  -1305,
  -1306,
  -1307,
  -1308,
  -1309,
  -1310,
  -1311,
  -1312,
  -1313,
  -1314,
  -1315,
  -1316,
  -1317,
  -1318,
  -1319,
  -1320,
  -1321,
  -1322,
  -1323,
  -1324,
  -1325,
  -1326,
  -1327,
  -1328,
  -1329,
  -1330,
  -1331,
  -1332,
  -1333,
  -1334,
  -1335,
  -1336,
  -1337,
  -1338,
  -1339,
  -1340,
  -1341,
  -1342,
  -1343,
  -1344,
  -1345,
  -1346,
  -1347,
  -1348,
  -1349,
  -1350,
  -1351,
  -1352,
  -1353,
  -1354,
  -1355,
  -1356,
  -1357,
  -1358,
  -1359,
  -1360,
  -1361,
  -1362,
  -1363,
  -1364,
  -1365,
  -1366,
  -1367,
  -1368,
  -1369,
  -1370,
  -1371,
  -1372,
  -1373,
  -1374,
  -1375,
  -1376,
  -1377,
  -1378,
  -1379,
  -1380,
  -1381,
  -1382,
  -1383,
  -1384,
  -1385,
  -1386,
  -1387,
  -1388,
  -1389,
  -1390,
  -1391,
  -1392,
  -1393,
  -1394,
  -1395,
  -1396,
  -1397,
  -1398,
  -1399,
  -1400,
  -1401,
  -1402,
  -1403,
  -1404,
  -1405,
  -1406,
  -1407,
  -1408,
  -1409,
  -1410,
  -1411,
  -1412,
  -1413,
  -1414,
  -1415,
  -1416,
  -1417,
  -1418,
  -1419,
  -1420,
  -1421,
  -1422,
  -1423,
  -1424,
  -1425,
  -1426,
  -1427,
  -1428,
  -1429,
  -1430,
  -1431,
  -1432,
  -1433,
  -1434,
  -1435,
  -1436,
  -1437,
  -1438,
  -1439,
  -1440,
  -1441,
  -1442,
  -1443,
  -1444,
  -1445,
  -1446,
  -1447,
  -1448,
  -1449,
  -1450,
  -1451,
  -1452,
  -1453,
  -1454,
  -1455,
  -1456,
  -1457,
  -1458,
  -1459,
  -1460,
  -1461,
  -1462,
  -1463,
  -1464,
  -1465,
  -1466,
  -1467,
  -1468,
  -1469,
  -1470,
  -1471,
  -1472,
  -1473,
  -1474,
  -1475,
  -1476,
  -1477,
  -1478,
  -1479,
  -1480,
  -1481,
  -1482,
  -1483,
  -1484,
  -1485,
  -1486,
  -1487,
  -1488,
  -1489,
  -1490,
  -1491,
  -1492,
  -1493,
  -1494,
  -1495,
  -1496,
  -1497,
  -1498,
  -1499,
  -1500,
  -1501,
  -1502,
  -1503,
  -1504,
  -1505,
  -1506,
  -1507,
  -1508,
  -1509,
  -1510,
  -1511,
  -1512,
  -1513,
  -1514,
  -1515,
  -1516,
  -1517,
  -1518,
  -1519,
  -1520,
  -1521,
  -1522,
  -1523,
  -1524,
  -1525,
  -1526,
  -1527,
  -1528,
  -1529,
  -1530,
  -1531,
  -1532,
  -1533,
  -1534,
  -1535,
  -1536,
  -1537,
  -1538,
  -1539,
  -1540,
  -1541,
  -1542,
  -1543,
  -1544,
  -1545,
  -1546,
  -1547,
  -1548,
  -1549,
  -1550,
  -1551,
  -1552,
  -1553,
  -1554,
  -1555,
  -1556,
  -1557,
  -1558,
  -1559,
  -1560,
  -1561,
  -1562,
  -1563,
  -1564,
  -1565,
  -1566,
  -1567,
  -1568,
  -1569,
  -1570,
  -1571,
  -1572,
  -1573,
  -1574,
  -1575,
  -1576,
  -1577,
  -1578,
  -1579,
  -1580,
  -1581,
  -1582,
  -1583,
  -1584,
  -1585,
  -1586,
  -1587,
  -1588,
  -1589,
  -1590,
  -1591,
  -1592,
  -1593,
  -1594,
  -1595,
  -1596,
  -1597,
  -1598,
  -1599,
  -1600,
  -1601,
  -1602,
  -1603,
  -1604,
  -1605,
  -1606,
  -1607,
  -1608,
  -1609,
  -1610,
  -1611,
  -1612,
  -1613,
  -1614,
  -1615,
  -1616,
  -1617,
  -1618,
  -1619,
  -1620,
  -1621,
  -1622,
  -1623,
  -1624,
  -1625,
  -1626,
  -1627,
  -1628,
  -1629,
  -1630,
  -1631,
  -1632,
  -1633,
  -1634,
  -1635,
  -1636,
  -1637,
  -1638,
  -1639,
  -1640,
  -1641,
  -1642,
  -1643,
  -1644,
  -1645,
  -1646,
  -1647,
  -1648,
  -1649,
  -1650,
  -1651,
  -1652,
  -1653,
  -1654,
  -1655,
  -1656,
  -1657,
  -1658,
  -1659,
  -1660,
  -1661,
  -1662,
  -1663,
  -1664,
  -1665,
  -1666,
  -1667,
  -1668,
  -1669,
  -1670,
  -1671,
  -1672,
  -1673,
  -1674,
  -1675,
  -1676,
  -1677,
  -1678,
  -1679,
  -1680,
  -1681,
  -1682,
  -1683,
  -1684,
  -1685,
  -1686,
  -1687,
  -1688,
  -1689,
  -1690,
  -1691,
  -1692,
  -1693,
  -1694,
  -1695,
  -1696,
  -1697,
  -1698,
  -1699,
  -1700,
  -1701,
  -1702,
  -1703,
  -1704,
  -1705,
  -1706,
  -1707,
  -1708,
  -1709,
  -1710,
  -1711,
  -1712,
  -1713,
  -1714,
  -1715,
  -1716,
  -1717,
  -1718,
  -1719,
  -1720,
  -1721,
  -1722,
  -1723,
  -1724,
  -1725,
  -1726,
  -1727,
  -1728,
  -1729,
  -1730,
  -1731,
  -1732,
  -1733,
  -1734,
  -1735,
  -1736,
  -1737,
  -1738,
  -1739,
  -1740,
  -1741,
  -1742,
  -1743,
  -1744,
  -1745,
  -1746,
  -1747,
  -1748,
  -1749,
  -1750,
  -1751,
  -1752,
  -1753,
  -1754,
  -1755,
  -1756,
  -1757,
  -1758,
  -1759,
  -1760,
  -1761,
  -1762,
  -1763,
  -1764,
  -1765,
  -1766,
  -1767,
  -1768,
  -1769,
  -1770,
  -1771,
  -1772,
  -1773,
  -1774,
  -1775,
  -1776,
  -1777,
  -1778,
  -1779,
  -1780,
  -1781,
  -1782,
  -1783,
  -1784,
  -1785,
  -1786,
  -1787,
  -1788,
  -1789,
  -1790,
  -1791,
  -1792,
  -1793,
  -1794,
  -1795,
  -1796,
  -1797,
  -1798,
  -1799,
  -1800,
  -1801,
  -1802,
  -1803,
  -1804,
  -1805,
  -1806,
  -1807,
  -1808,
  -1809,
  -1810,
  -1811,
  -1812,
  -1813,
  -1814,
  -1815,
  -1816,
  -1817,
  -1818,
  -1819,
  -1820,
  -1821,
  -1822,
  -1823,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  24,
  25,
  26,
  27,
  28,
  29,
  30,
  31,
  32,
  33,
  34,
  35,
  36,
  37,
  38,
  39,
  40,
  41,
  42,
  43,
  44,
  45,
  46,
  47,
  48,
  49,
  50,
  51,
  52,
  53,
  54,
  55,
  56,
  57,
  58,
  59,
  60,
  61,
  62,
  63,
  64,
  65,
  66,
  67,
  68,
  69,
  70,
  71,
  72,
  73,
  74,
  75,
  76,
  77,
  78,
  79,
  80,
  81,
  82,
  83,
  84,
  85,
  86,
  87,
  88,
  89,
  90,
  91,
  92,
  93,
  94,
  95,
  96,
  97,
  98,
  99,
  100,
  101,
  102,
  103,
  104,
  105,
  106,
  107,
  108,
  109,
  110,
  111,
  112,
  113,
  114,
  115,
  116,
  117,
  118,
  119,
  120,
  121,
  122,
  123,
  124,
  125,
  126,
  127,
  128,
  129,
  130,
  131,
  132,
  133,
  134,
  135,
  136,
  137,
  138,
  139,
  140,
  141,
  142,
  143,
  144,
  145,
  146,
  147,
  148,
  149,
  150,
  151,
  152,
  153,
  154,
  155,
  156,
  157,
  158,
  159,
  160,
  161,
  162,
  163,
  164,
  165,
  166,
  167,
  168,
  169,
  170,
  171,
  172,
  173,
  174,
  175,
  176,
  177,
  178,
  179,
  180,
  181,
  182,
  183,
  184,
  185,
  186,
  187,
  188,
  189,
  190,
  191,
  192,
  193,
  194,
  195,
  196,
  197,
  198,
  199,
  200,
  201,
  202,
  203,
  204,
  205,
  206,
  207,
  208,
  209,
  210,
  211,
  212,
  213,
  214,
  215,
  216,
  217,
  218,
  219,
  220,
  221,
  222,
  223,
  224,
  225,
  226,
  227,
  228,
  229,
  230,
  231,
  232,
  233,
  234,
  235,
  236,
  237,
  238,
  239,
  240,
  241,
  242,
  243,
  244,
  245,
  246,
  247,
  248,
  249,
  250,
  251,
  252,
  253,
  254,
  255,
  256,
  257,
  258,
  259,
  260,
  261,
  262,
  263,
  264,
  265,
  266,
  267,
  268,
  269,
  270,
  271,
  272,
  273,
  274,
  275,
  276,
  277,
  278,
  279,
  280,
  281,
  282,
  283,
  284,
  285,
  286,
  287,
  288,
  289,
  290,
  291,
  292,
  293,
  294,
  295,
  296,
  297,
  298,
  299,
  300,
  301,
  302,
  303,
  304,
  305,
  306,
  307,
  308,
  309,
  310,
  311,
  312,
  313,
  314,
  315,
  316,
  317,
  318,
  319,
  320,
  321,
  322,
  323,
  324,
  325,
  326,
  327,
  328,
  329,
  330,
  331,
  332,
  333,
  334,
  335,
  336,
  337,
  338,
  339,
  340,
  341,
  342,
  343,
  344,
  345,
  346,
  347,
  348,
  349,
  350,
  351,
  352,
  353,
  354,
  355,
  356,
  357,
  358,
  359,
  360,
  361,
  362,
  363,
  364,
  365,
  366,
  367,
  368,
  369,
  370,
  371,
  372,
  373,
  374,
  375,
  376,
  377,
  378,
  379,
  380,
  381,
  382,
  383,
  384,
  385,
  386,
  387,
  388,
  389,
  390,
  391,
  392,
  393,
  394,
  395,
  396,
  397,
  398,
  399,
  400,
  401,
  402,
  403,
  404,
  405,
  406,
  407,
  408,
  409,
  410,
  411,
  412,
  413,
  414,
  415,
  416,
  417,
  418,
  419,
  420,
  421,
  422,
  423,
  424,
  425,
  426,
  427,
  428,
  429,
  430,
  431,
  432,
  433,
  434,
  435,
  436,
  437,
  438,
  439,
  440,
  441,
  442,
  443,
  444,
  445,
  446,
  447,
  448,
  449,
  450,
  451,
  452,
  453,
  454,
  455,
  456,
  457,
  458,
  459,
  460,
  461,
  462,
  463,
  464,
  465,
  466,
  467,
  468,
  469,
  470,
  471,
  472,
  473,
  474,
  475,
  476,
  477,
  478,
  479,
  480,
  481,
  482,
  483,
  484,
  485,
  486,
  487,
  488,
  489,
  490,
  491,
  492,
  493,
  494,
  495,
  496,
  497,
  498,
  499,
  500,
  501,
  502,
  503,
  504,
  505,
  506,
  507,
  508,
  509,
  510,
  511,
  512,
  513,
  514,
  515,
  516,
  517,
  518,
  519,
  520,
  521,
  522,
  523,
  524,
  525,
  526,
  527,
  528,
  529,
  530,
  531,
  532,
  533,
  534,
  535,
  536,
  537,
  538,
  539,
  540,
  541,
  542,
  543,
  544,
  545,
  546,
  547,
  548,
  549,
  550,
  551,
  552,
  553,
  554,
  555,
  556,
  557,
  558,
  559,
  560,
  561,
  562,
  563,
  564,
  565,
  566,
  567,
  568,
  569,
  570,
  571,
  572,
  573,
  574,
  575,
  576,
  577,
  578,
  579,
  580,
  581,
  582,
  583,
  584,
  585,
  586,
  587,
  588,
  589,
  590,
  591,
  592,
  593,
  594,
  595,
  596,
  597,
  598,
  599,
  600,
  601,
  602,
  603,
  604,
  605,
  606,
  607,
  608,
  609,
  610,
  611,
  612,
  613,
  614,
  615,
  616,
  617,
  618,
  619,
  620,
  621,
  622,
  623,
  624,
  625,
  626,
  627,
  628,
  629,
  630,
  631,
  632,
  633,
  634,
  635,
  636,
  637,
  638,
  639,
  640,
  641,
  642,
  643,
  644,
  645,
  646,
  647,
  648,
  649,
  650,
  651,
  652,
  653,
  654,
  655,
  656,
  657,
  658,
  659,
  660,
  661,
  662,
  663,
  664,
  665,
  666,
  667,
  668,
  669,
  670,
  671,
  672,
  673,
  674,
  675,
  676,
  677,
  678,
  679,
  680,
  681,
  682,
  683,
  684,
  685,
  686,
  687,
  688,
  689,
  690,
  691,
  692,
  693,
  694,
  695,
  696,
  697,
  698,
  699,
  700,
  701,
  702,
  703,
  704,
  705,
  706,
  707,
  708,
  709,
  710,
  711,
  712,
  713,
  714,
  715,
  716,
  717,
  718,
  719,
  720,
  721,
  722,
  723,
  724,
  725,
  726,
  727,
  728,
  729,
  730,
  731,
  732,
  733,
  734,
  735,
  736,
  737,
  738,
  739,
  740,
  741,
  742,
  743,
  744,
  745,
  746,
  747,
  748,
  749,
  750,
  751,
  752,
  753,
  754,
  755,
  756,
  757,
  758,
  759,
  760,
  761,
  762,
  763,
  764,
  765,
  766,
  767,
  768,
  769,
  770,
  771,
  772,
  773,
  774,
  775,
  776,
  777,
  778,
  779,
  780,
  781,
  782,
  783,
  784,
  785,
  786,
  787,
  788,
  789,
  790,
  791,
  792,
  793,
  794,
  795,
  796,
  797,
  798,
  799,
  800,
  801,
  802,
  803,
  804,
  805,
  806,
  807,
  808,
  809,
  810,
  811,
  812,
  813,
  814,
  815,
  816,
  817,
  818,
  819,
  820,
  821,
  822,
  823,
  824,
  825,
  826,
  827,
  828,
  829,
  830,
  831,
  832,
  833,
  834,
  835,
  836,
  837,
  838,
  839,
  840,
  841,
  842,
  843,
  844,
  845,
  846,
  847,
  848,
  849,
  850,
  851,
  852,
  853,
  854,
  855,
  856,
  857,
  858,
  859,
  860,
  861,
  862,
  863,
  864,
  865,
  866,
  867,
  868,
  869,
  870,
  871,
  872,
  873,
  874,
  875,
  876,
  877,
  878,
  879,
  880,
  881,
  882,
  883,
  884,
  885,
  886,
  887,
  888,
  889,
  890,
  891,
  892,
  893,
  894,
  895,
  896,
  897,
  898,
  899,
  900,
  901,
  902,
  903,
  904,
  905,
  906,
  907,
  908,
  909,
  910,
  911,
  912,
  913,
  914,
  915,
  916,
  917,
  918,
  919,
  920,
  921,
  922,
  923,
  924,
  925,
  926,
  927,
  928,
  929,
  930,
  931,
  932,
  933,
  934,
  935,
  936,
  937,
  938,
  939,
  940,
  941,
  942,
  943,
  944,
  945,
  946,
  947,
  948,
  949,
  950,
  951,
  952,
  953,
  954,
  955,
  956,
  957,
  958,
  959,
  960,
  961,
  962,
  963,
  964,
  965,
  966,
  967,
  968,
  969,
  970,
  971,
  972,
  973,
  974,
  975,
  976,
  977,
  978,
  979,
  980,
  981,
  982,
  983,
  984,
  985,
  986,
  987,
  988,
  989,
  990,
  991,
  992,
  993,
  994,
  995,
  996,
  997,
  998,
  999,
  1000,
  1001,
  1002,
  1003,
  1004,
  1005,
  1006,
  1007,
  1008,
  1009,
  1010,
  1011,
  1012,
  1013,
  1014,
  1015,
  1016,
  1017,
  1018,
  1019,
  1020,
  1021,
  1022,
  1023,
  1024,
  1025,
  1026,
  1027,
  1028,
  1029,
  1030,
  1031,
  1032,
  1033,
  1034,
  1035,
  1036,
  1037,
  1038,
  1039,
  1040,
  1041,
  1042,
  1043,
  1044,
  1045,
  1046,
  1047,
  1048,
  1049,
  1050,
  1051,
  1052,
  1053,
  1054,
  1055,
  1056,
  1057,
  1058,
  1059,
  1060,
  1061,
  1062,
  1063,
  1064,
  1065,
  1066,
  1067,
  1068,
  1069,
  1070,
  1071,
  1072,
  1073,
  1074,
  1075,
  1076,
  1077,
  1078,
  1079,
  1080,
  1081,
  1082,
  1083,
  1084,
  1085,
  1086,
  1087,
  1088,
  1089,
  1090,
  1091,
  1092,
  1093,
  1094,
  1095,
  1096,
  1097,
  1098,
  1099,
  1100,
  1101,
  1102,
  1103,
  1104,
  1105,
  1106,
  1107,
  1108,
  1109,
  1110,
  1111,
  1112,
  1113,
  1114,
  1115,
  1116,
  1117,
  1118,
  1119,
  1120,
  1121,
  1122,
  1123,
  1124,
  1125,
  1126,
  1127,
  1128,
  1129,
  1130,
  1131,
  1132,
  1133,
  1134,
  1135,
  1136,
  1137,
  1138,
  1139,
  1140,
  1141,
  1142,
  1143,
  1144,
  1145,
  1146,
  1147,
  1148,
  1149,
  1150,
  1151,
  1152,
  1153,
  1154,
  1155,
  1156,
  1157,
  1158,
  1159,
  1160,
  1161,
  1162,
  1163,
  1164,
  1165,
  1166,
  1167,
  1168,
  1169,
  1170,
  1171,
  1172,
  1173,
  1174,
  1175,
  1176,
  1177,
  1178,
  1179,
  1180,
  1181,
  1182,
  1183,
  1184,
  1185,
  1186,
  1187,
  1188,
  1189,
  1190,
  1191,
  1192,
  1193,
  1194,
  1195,
  1196,
  1197,
  1198,
  1199,
  1200,
  1201,
  1202,
  1203,
  1204,
  1205,
  1206,
  1207,
  1208,
  1209,
  1210,
  1211,
  1212,
  1213,
  1214,
  1215,
  1216,
  1217,
  1218,
  1219,
  1220,
  1221,
  1222,
  1223,
  1224,
  1225,
  1226,
  1227,
  1228,
  1229,
  1230,
  1231,
  1232,
  1233,
  1234,
  1235,
  1236,
  1237,
  1238,
  1239,
  1240,
  1241,
  1242,
  1243,
  1244,
  1245,
  1246,
  1247,
  1248,
  1249,
  1250,
  1251,
  1252,
  1253,
  1254,
  1255,
  1256,
  1257,
  1258,
  1259,
  1260,
  1261,
  1262,
  1263,
  1264,
  1265,
  1266,
  1267,
  1268,
  1269,
  1270,
  1271,
  1272,
  1273,
  1274,
  1275,
  1276,
  1277,
  1278,
  1279,
  1280,
  1281,
  1282,
  1283,
  1284,
  1285,
  1286,
  1287,
  1288,
  1289,
  1290,
  1291,
  1292,
  1293,
  1294,
  1295,
  1296,
  1297,
  1298,
  1299,
  1300,
  1301,
  1302,
  1303,
  1304,
  1305,
  1306,
  1307,
  1308,
  1309,
  1310,
  1311,
  1312,
  1313,
  1314,
  1315,
  1316,
  1317,
  1318,
  1319,
  1320,
  1321,
  1322,
  1323,
  1324,
  1325,
  1326,
  1327,
  1328,
  1329,
  1330,
  1331,
  1332,
  1333,
  1334,
  1335,
  1336,
  1337,
  1338,
  1339,
  1340,
  1341,
  1342,
  1343,
  1344,
  1345,
  1346,
  1347,
  1348,
  1349,
  1350,
  1351,
  1352,
  1353,
  1354,
  1355,
  1356,
  1357,
  1358,
  1359,
  1360,
  1361,
  1362,
  1363,
  1364,
  1365,
  1366,
  1367,
  1368,
  1369,
  1370,
  1371,
  1372,
  1373,
  1374,
  1375,
  1376,
  1377,
  1378,
  1379,
  1380,
  1381,
  1382,
  1383,
  1384,
  1385,
  1386,
  1387,
  1388,
  1389,
  1390,
  1391,
  1392,
  1393,
  1394,
  1395,
  1396,
  1397,
  -51,
  -52,
  -53,
  -54,
  -55,
  -56,
  -57,
  -58,
  -59,
  -60,
  -61,
  -62,
  -63,
  -64,
  -65,
  -66,
  -67,
  -68,
  -69,
  -70,
  -71,
  -72,
  -73,
  -74,
  -75,
  -76,
  -77,
  -78,
  -79,
  -80,
  -81,
  -82,
  -83,
  -84,
  -85,
  -86,
  -87,
  -88,
  -89,
  -90,
  -91,
  -92,
  -93,
  -94,
  -95,
  -96,
  -97,
  -98,
  -99,
  -100,
  -101,
  -102,
  -103,
  -104,
  -105,
  -106,
  -107,
  -108,
  -109,
  -110,
  -111,
  -112,
  -113,
  -114,
  -115,
  -116,
  -117,
  -118,
  -119,
  -120,
  -121,
  -122,
  -123,
  -124,
  -125,
  -126,
  -127,
  -128,
  -129,
  -130,
  -131,
  -132,
  -133,
  -134,
  -135,
  -136,
  -137,
  -138,
  -139,
  -140,
  -141,
  -142,
  -143,
  -144,
  -145,
  -146,
  -147,
  -148,
  -149,
  -150,
  -151,
  -152,
  -153,
  -154,
  -155,
  -156,
  -157,
  -158,
  -159,
  -160,
  -161,
  -162,
  -163,
  -164,
  -165,
  -166,
  -167,
  -168,
  -169,
  -170,
  -171,
  -172,
  -173,
  -174,
  -175,
  -176,
  -177,
  -178,
  -179,
  -180,
  -181,
  -182,
  -183,
  -184,
  -185,
  -186,
  -187,
  -188,
  -189,
  -190,
  -191,
  -192,
  -193,
  -194,
  -195,
  -196,
  -197,
  -198,
  -199,
  -200,
  -201,
  -202,
  -203,
  -204,
  -205,
  -206,
  -207,
  -208,
  -209,
  -210,
  -211,
  -212,
  -213,
  -214,
  -215,
  -216,
  -217,
  -218,
  -219,
  -220,
  -221,
  -222,
  -223,
  -224,
  -225,
  -226,
  -1824,
  -1825,
  -1826,
  -1827,
  -1828,
  -1829,
  -1830,
  -1831,
  -1832,
  -1833,
  -1834,
  -1835,
  -1836,
  -1837,
  -1838,
  -1839,
  -1840,
  -1841,
  -1842,
  -1843,
  -1844,
  -1845,
  -1846,
  -1847,
  -1848,
  -1849,
  -1850,
  -1851,
  -1852,
  -1853,
  -1854,
  -1855,
  -1856,
  -1857,
  -1858,
  -1859,
  -1860,
  -1861,
  -1862,
  -1863,
  -1864,
  -1865,
  -1866,
  -1867,
  -1868,
  -1869,
  -1870,
  -1871,
  -1872,
  -1873,
  -1874,
  -1875,
  -1876,
  -1877,
  -1878,
  -1879,
  -1880,
  -1881,
  -1882,
  -1883,
  -1884,
  -1885,
  -1886,
  -1887,
  -1888,
  -1889,
  -1890,
  -1891,
  -1892,
  -1893,
  -1894,
  -1895,
  -1896,
  -1897,
  -1898,
  -1899,
  -1900,
  -1901,
  -1902,
  -1903,
  -1904,
  -1905,
  -1906,
  -1907,
  -1908,
  -1909,
  -1910,
  -1911,
  -1912,
  -1913,
  -1914,
  -1915,
  -1916,
  -1917,
  -1918,
  -1919,
  -1920,
  -1921,
  -1922,
  -1923,
  -1924,
  -1925,
  -1926,
  -1927,
  -1928,
  -1929,
  -1930,
  -1931,
  -1932,
  -1933,
  -1934,
  -1935,
  -1936,
  -1937,
  -1938,
  -1939,
  -1940,
  -1941,
  -1942,
  -1943,
  -1944,
  -1945,
  -1946,
  -1947,
  -1948,
  -1949,
  -1950,
  -1951,
  -1952,
  -1953,
  -1954,
  -1955,
  -1956,
  -1957,
  -1958,
  -1959,
  -1960,
  -1961,
  -1962,
  -1963,
  -1964,
  -1965,
  -1966,
  -1967,
  -1968,
  -1969,
  -1970,
  -1971,
  -1972,
  -1973,
  -1974,
  -1975,
  -1976,
  -1977,
  -1978,
  -1979,
  -1980,
  -1981,
  -1982,
  -1983,
  -1984,
  -1985,
  -1986,
  -1987,
  -1988,
  -1989,
  -1990,
  -1991,
  -1992,
  -1993,
  -1994,
  -1995,
  -1996,
  -1997,
  -1998,
  -1999,
  1398,
  -50,
  -2000,
  1399,
  1400,
  1401,
  1402,
  1403,
  1404,
  1405,
  1406,
  1407,
  1408,
  1409,
  1410,
  1411,
  1412,
  1413,
  1414,
  1415,
  1416,
  1417,
  1418,
  1419,
  1420,
  1421,
  1422,
  1423,
  1424,
  1425,
  1426,
  1427,
  1428,
  1429,
  1430,
  1431,
  1432,
  1433,
  1434,
  1435,
  1436,
  1437,
  1438,
  1439,
  1440,
  1441,
  1442,
  1443,
  1444,
  1445,
  1446,
  1447,
  1448,
  1449,
  1450,
  1451,
  1452,
  1453,
  1454,
  1455,
  1456,
  1457,
  1458,
  1459,
  1460,
  1461,
  1462,
  1463,
  1464,
  1465,
  1466,
  1467,
  1468,
  1469,
  1470,
  1471,
  1472,
  1473,
  1474,
  1475,
  1476,
  1477,
  1478,
  1479,
  1480,
  1481,
  1482,
  1483,
  1484,
  1485,
  1486,
  1487,
  1488,
  1489,
  1490,
  1491,
  1492,
  1493,
  1494,
  1495,
  1496,
  1497,
  -49,
  -2001,
  -48,
  -2002,
  -47,
  -2003,
  -46,
  -2004,
  1498,
  1499,
  1500,
  1501,
  1502,
  1503,
  1504,
  1505,
  1506,
  1507,
  1508,
  1509,
  1510,
  1511,
  1512,
  1513,
  1514,
  1515,
  1516,
  1517,
  1518,
  1519,
  1520,
  1521,
  1522,
  1523,
  1524,
  1525,
  1526,
  1527,
  1528,
  1529,
  1530,
  1531,
  1532,
  1533,
  1534,
  1535,
  1536,
  1537,
  1538,
  1539,
  1540,
  1541,
  1542,
  1543,
  1544,
  1545,
  1546,
  1547,
  1548,
  1549,
  1550,
  1551,
  1552,
  1553,
  1554,
  1555,
  1556,
  1557,
  1558,
  1559,
  1560,
  1561,
  1562,
  1563,
  1564,
  1565,
  1566,
  1567,
  1568,
  1569,
  1570,
  1571,
  1572,
  1573,
  1574,
  1575,
  1576,
  1577,
  1578,
  1579,
  1580,
  1581,
  1582,
  1583,
  1584,
  1585,
  1586,
  1587,
  1588,
  1589,
  1590,
  1591,
  1592,
  1593,
  1594,
  1595,
  1596,
  1597,
  1598,
  1599,
  1600,
  1601,
  1602,
  1603,
  1604,
  1605,
  1606,
  1607,
  1608,
  1609,
  1610,
  1611,
  1612,
  1613,
  1614,
  1615,
  1616,
  1617,
  1618,
  1619,
  1620,
  1621,
  1622,
  1623,
  1624,
  1625,
  1626,
  1627,
  1628,
  1629,
  1630,
  1631,
  1632,
  1633,
  1634,
  1635,
  1636,
  1637,
  1638,
  1639,
  1640,
  1641,
  1642,
  1643,
  1644,
  1645,
  1646,
  1647,
  1648,
  1649,
  1650,
  1651,
  1652,
  1653,
  1654,
  1655,
  1656,
  1657,
  1658,
  1659,
  1660,
  1661,
  1662,
  1663,
  1664,
  1665,
  1666,
  1667,
  1668,
  1669,
  1670,
  1671,
  1672,
  1673,
  1674,
  -45,
  -2005,
  1675,
  -44,
  -2006,
  1676,
  1677,
  1678,
  1679,
  1680,
  1681,
  1682,
  1683,
  1684,
  1685,
  1686,
  1687,
  1688,
  1689,
  1690,
  1691,
  1692,
  1693,
  1694,
  1695,
  1696,
  1697,
  1698,
  1699,
  1700,
  1701,
  1702,
  1703,
  1704,
  1705,
  1706,
  1707,
  1708,
  1709,
  1710,
  1711,
  1712,
  1713,
  1714,
  1715,
  1716,
  1717,
  1718,
  1719,
  1720,
  1721,
  1722,
  1723,
  1724,
  -43,
  -2007,
  1725,
  -42,
  -2008,
  -41,
  -2009,
  1726,
  -40,
  -2010,
  -39,
  -2011,
  -38,
  -2012,
  1727,
  -37,
  -2013,
  1728,
  1729,
  1730,
  1731,
  1732,
  1733,
  1734,
  1735,
  1736,
  1737,
  1738,
  1739,
  1740,
  1741,
  1742,
  1743,
  1744,
  1745,
  1746,
  1747,
  1748,
  1749,
  1750,
  1751,
  1752,
  1753,
  1754,
  1755,
  1756,
  1757,
  1758,
  1759,
  1760,
  1761,
  1762,
  1763,
  1764,
  1765,
  1766,
  1767,
  1768,
  1769,
  1770,
  1771,
  1772,
  1773,
  1774,
  1775,
  1776,
  1777,
  1778,
  1779,
  1780,
  1781,
  1782,
  1783,
  1784,
  1785,
  1786,
  1787,
  1788,
  1789,
  1790,
  1791,
  1792,
  1793,
  1794,
  1795,
  1796,
  1797,
  1798,
  1799,
  1800,
  1801,
  1802,
  1803,
  1804,
  1805,
  1806,
  1807,
  1808,
  1809,
  1810,
  1811,
  1812,
  1813,
  1814,
  1815,
  1816,
  -36,
  -2014,
  -35,
  -2015,
  1817,
  -34,
  -2016,
  1818,
  -33,
  -2017,
  1819,
  1820,
  1821,
  1822,
  1823,
  1824,
  1825,
  1826,
  1827,
  1828,
  1829,
  1830,
  1831,
  1832,
  1833,
  1834,
  1835,
  1836,
  1837,
  1838,
  1839,
  1840,
  1841,
  1842,
  1843,
  -32,
  -2018,
  -31,
  -2019,
  1844,
  -30,
  -2020,
  1845,
  -29,
  -2021,
  1846,
  -28,
  -2022,
  -27,
  -2023,
  1847,
  -26,
  -2024,
  -25,
  -2025,
  1848,
  -24,
  -2026,
  -23,
  -2027,
  1849,
  -22,
  -2028,
  1850,
  -21,
  -2029,
  1851,
  -20,
  -2030,
  -19,
  -2031,
  1852,
  1853,
  1854,
  1855,
  1856,
  1857,
  1858,
  1859,
  1860,
  1861,
  1862,
  1863,
  1864,
  1865,
  1866,
  1867,
  1868,
  1869,
  1870,
  1871,
  1872,
  1873,
  1874,
  1875,
  1876,
  1877,
  1878,
  1879,
  1880,
  1881,
  1882,
  1883,
  1884,
  1885,
  1886,
  1887,
  1888,
  1889,
  1890,
  1891,
  1892,
  1893,
  1894,
  1895,
  1896,
  1897,
  1898,
  1899,
  1900,
  1901,
  1902,
  1903,
  1904,
  1905,
  1906,
  1907,
  1908,
  1909,
  1910,
  1911,
  1912,
  1913,
  1914,
  1915,
  1916,
  1917,
  1918,
  1919,
  1920,
  1921,
  1922,
  1923,
  1924,
  1925,
  -18,
  -2032,
  1926,
  1927,
  1928,
  1929,
  1930,
  1931,
  1932,
  1933,
  1934,
  1935,
  1936,
  1937,
  1938,
  1939,
  1940,
  1941,
  1942,
  1943,
  1944,
  1945,
  1946,
  1947,
  1948,
  1949,
  1950,
  1951,
  1952,
  1953,
  1954,
  1955,
  1956,
  1957,
  1958,
  1959,
  1960,
  1961,
  1962,
  1963,
  1964,
  1965,
  1966,
  1967,
  1968,
  1969,
  1970,
  1971,
  1972,
  1973,
  -17,
  -2033,
  1974,
  1975,
  1976,
  1977,
  1978,
  1979,
  1980,
  1981,
  1982,
  1983,
  1984,
  1985,
  1986,
  1987,
  1988,
  1989,
  1990,
  1991,
  -16,
  -2034,
  1992,
  1993,
  1994,
  1995,
  1996,
  1997,
  1998,
  1999,
  2000,
  2001,
  -15,
  -2035,
  2002,
  2003,
  -14,
  -2036,
  2004,
  2005,
  -13,
  -2037,
  2006,
  -12,
  -2038,
  2007,
  2008,
  2009,
  2010,
  2011,
  -11,
  -2039,
  -10,
  -2040,
  2012,
  2013,
  -9,
  -2041,
  2014,
  -8,
  -2042,
  2015,
  -7,
  -2043,
  -6,
  -2044,
  2016,
  2017,
  -5,
  -2045,
  2018,
  -4,
  -2046,
  2019,
  2020,
  -3,
  -2047,
  -2,
  -2048,
  2021,
  -1,
  2022,
  2023,
  2024,
  2025,
  2026,
  2027,
  2028,
  2029,
  2030,
  2031,
  2032,
  2033,
  2034,
  2035,
  2036,
  2037,
  2038,
  2039,
  2040,
  2041,
  2042,
  2043,
  2044,
  2045,
  2046,
  2047
]
